import React, { useEffect, useState, lazy, createElement } from 'react';
import { Routes, Route, Navigate } from 'react-router-dom';
import { AnimatePresence, motion } from 'framer-motion';
import { PenLine, Clock, Eye, X, Minus, Check, ChevronRight, ChevronDown, ArrowUpRight, ThumbsUp, MessageCircle, Info, CheckCircle2, FileText, Shield, Lock, RefreshCcw, Settings, SendIcon } from 'lucide-react';
type LegalPage = 'impressum' | 'datenschutz' | 'agb' | 'widerruf' | 'cookie' | null;
const legalContent: Record<Exclude<LegalPage, null>, {
  title: string;
  content: JSX.Element;
}> = {
  impressum: {
    title: 'Impressum',
    content: <div className="space-y-6" data-id="element-0">
        <section data-id="element-1">
          <h2 className="text-xl font-bold text-brand-navy mb-3 font-[Merriweather,_serif]" data-id="element-2">
            Angaben gemäß § 5 TMG
          </h2>
          <p className="font-['Open_Sans',_sans-serif] text-[15px] text-gray-700" data-id="element-3">
            Emerald Health Solutions Ltd.
            <br data-id="element-4" />
            Unit 12, Business Centre, Sandyford
            <br data-id="element-5" />
            Dublin 18, D18 X2P9
            <br data-id="element-6" />
            Irland
          </p>
        </section>

        <section data-id="element-7">
          <h2 className="text-xl font-bold text-brand-navy mb-3 font-[Merriweather,_serif]" data-id="element-8">
            Vertreten durch
          </h2>
          <p className="font-['Open_Sans',_sans-serif] text-[15px] text-gray-700" data-id="element-9">
            Geschäftsführer: Liam O'Connor
          </p>
        </section>

        <section data-id="element-10">
          <h2 className="text-xl font-bold text-brand-navy mb-3 font-[Merriweather,_serif]" data-id="element-11">
            Kontakt
          </h2>
          <p className="font-['Open_Sans',_sans-serif] text-[15px] text-gray-700" data-id="element-12">
            Telefon: +353 1 496 0123
            <br data-id="element-13" />
            E-Mail: contact@emerald-health.ie
          </p>
        </section>

        <section data-id="element-14">
          <h2 className="text-xl font-bold text-brand-navy mb-3 font-[Merriweather,_serif]" data-id="element-15">
            Registereintrag
          </h2>
          <p className="font-['Open_Sans',_sans-serif] text-[15px] text-gray-700" data-id="element-16">
            Eintragung im irischen Handelsregister
            <br data-id="element-17" />
            Handelsregisternummer: 742185
          </p>
        </section>

        <section data-id="element-18">
          <h2 className="text-xl font-bold text-brand-navy mb-3 font-[Merriweather,_serif]" data-id="element-19">
            Umsatzsteuer-ID
          </h2>
          <p className="font-['Open_Sans',_sans-serif] text-[15px] text-gray-700" data-id="element-20">
            Umsatzsteuer-Identifikationsnummer:
            <br data-id="element-21" />
            IE9988776W
          </p>
        </section>

        <section data-id="element-22">
          <h2 className="text-xl font-bold text-brand-navy mb-3 font-[Merriweather,_serif]" data-id="element-23">
            Verantwortlich für den Inhalt nach § 55 Abs. 2 RStV
          </h2>
          <p className="font-['Open_Sans',_sans-serif] text-[15px] text-gray-700" data-id="element-24">
            Liam O'Connor
            <br data-id="element-25" />
            Unit 12, Business Centre, Sandyford
            <br data-id="element-26" />
            Dublin 18, D18 X2P9
            <br data-id="element-27" />
            Irland
          </p>
        </section>
      </div>
  },
  datenschutz: {
    title: 'Datenschutzerklärung',
    content: <div className="space-y-6" data-id="element-28">
        <section data-id="element-29">
          <h2 className="text-xl font-bold text-brand-navy mb-3 font-[Merriweather,_serif]" data-id="element-30">
            1. Datenschutz auf einen Blick
          </h2>
          <h3 className="text-lg font-semibold text-brand-navy mb-2 font-[Merriweather,_serif]" data-id="element-31">
            Allgemeine Hinweise
          </h3>
          <p className="font-['Open_Sans',_sans-serif] text-[15px] text-gray-700 mb-4" data-id="element-32">
            Die folgenden Hinweise geben einen einfachen Überblick darüber, was
            mit Ihren personenbezogenen Daten passiert, wenn Sie diese Website
            besuchen. Personenbezogene Daten sind alle Daten, mit denen Sie
            persönlich identifiziert werden können.
          </p>
        </section>

        <section data-id="element-33">
          <h2 className="text-xl font-bold text-brand-navy mb-3 font-[Merriweather,_serif]" data-id="element-34">
            2. Datenerfassung auf dieser Website
          </h2>
          <h3 className="text-lg font-semibold text-brand-navy mb-2 font-[Merriweather,_serif]" data-id="element-35">
            Wer ist verantwortlich für die Datenerfassung auf dieser Website?
          </h3>
          <p className="font-['Open_Sans',_sans-serif] text-[15px] text-gray-700 mb-4" data-id="element-36">
            Die Datenverarbeitung auf dieser Website erfolgt durch den
            Websitebetreiber. Dessen Kontaktdaten können Sie dem Impressum
            dieser Website entnehmen.
          </p>
          <h3 className="text-lg font-semibold text-brand-navy mb-2 font-[Merriweather,_serif]" data-id="element-37">
            Wie erfassen wir Ihre Daten?
          </h3>
          <p className="font-['Open_Sans',_sans-serif] text-[15px] text-gray-700 mb-4" data-id="element-38">
            Ihre Daten werden zum einen dadurch erhoben, dass Sie uns diese
            mitteilen. Hierbei kann es sich z. B. um Daten handeln, die Sie in
            ein Kontaktformular eingeben. Andere Daten werden automatisch oder
            nach Ihrer Einwilligung beim Besuch der Website durch unsere
            IT-Systeme erfasst. Das sind vor allem technische Daten (z. B.
            Internetbrowser, Betriebssystem oder Uhrzeit des Seitenaufrufs).
          </p>
          <h3 className="text-lg font-semibold text-brand-navy mb-2 font-[Merriweather,_serif]" data-id="element-39">
            Wofür nutzen wir Ihre Daten?
          </h3>
          <p className="font-['Open_Sans',_sans-serif] text-[15px] text-gray-700 mb-4" data-id="element-40">
            Ein Teil der Daten wird erhoben, um eine fehlerfreie Bereitstellung
            der Website zu gewährleisten. Andere Daten können zur Analyse Ihres
            Nutzerverhaltens verwendet werden.
          </p>
        </section>

        <section data-id="element-41">
          <h2 className="text-xl font-bold text-brand-navy mb-3 font-[Merriweather,_serif]" data-id="element-42">
            3. Cookies und Server-Log-Dateien
          </h2>
          <p className="font-['Open_Sans',_sans-serif] text-[15px] text-gray-700 mb-4" data-id="element-43">
            Unsere Internetseiten verwenden so genannte „Cookies". Weitere
            Informationen hierzu finden Sie in unserer Cookie-Richtlinie.
          </p>
          <p className="font-['Open_Sans',_sans-serif] text-[15px] text-gray-700" data-id="element-44">
            Der Provider der Seiten erhebt und speichert automatisch
            Informationen in so genannten Server-Log-Dateien, die Ihr Browser
            automatisch an uns übermittelt. Dies sind: Browsertyp und
            Browserversion, verwendetes Betriebssystem, Referrer URL, Hostname
            des zugreifenden Rechners, Uhrzeit der Serveranfrage und IP-Adresse.
          </p>
        </section>

        <section data-id="element-45">
          <h2 className="text-xl font-bold text-brand-navy mb-3 font-[Merriweather,_serif]" data-id="element-46">
            4. Ihre Rechte
          </h2>
          <p className="font-['Open_Sans',_sans-serif] text-[15px] text-gray-700 mb-4" data-id="element-47">
            Sie haben jederzeit das Recht, unentgeltlich Auskunft über Herkunft,
            Empfänger und Zweck Ihrer gespeicherten personenbezogenen Daten zu
            erhalten. Sie haben außerdem ein Recht, die Berichtigung,
            Einschränkung der Verarbeitung oder Löschung dieser Daten zu
            verlangen. Zudem steht Ihnen das Recht auf Datenübertragbarkeit zu.
            Wenn Sie eine Einwilligung zur Datenverarbeitung erteilt haben,
            können Sie diese Einwilligung jederzeit für die Zukunft widerrufen.
          </p>
          <p className="font-['Open_Sans',_sans-serif] text-[15px] text-gray-700 mb-4" data-id="element-48">
            Des Weiteren steht Ihnen ein Beschwerderecht bei der zuständigen
            Aufsichtsbehörde zu. Zuständig ist die irische Datenschutzbehörde
            (Data Protection Commission - DPC).
          </p>
        </section>

        <section data-id="element-49">
          <h2 className="text-xl font-bold text-brand-navy mb-3 font-[Merriweather,_serif]" data-id="element-50">
            5. Kontakt
          </h2>
          <p className="font-['Open_Sans',_sans-serif] text-[15px] text-gray-700" data-id="element-51">
            Wenn Sie Fragen zum Datenschutz haben, schreiben Sie uns bitte eine
            E-Mail an: contact@emerald-health.ie.
          </p>
        </section>
      </div>
  },
  agb: {
    title: 'Nutzungsbedingungen',
    content: <div className="space-y-6" data-id="element-52">
        <section data-id="element-53">
          <h2 className="text-xl font-bold text-brand-navy mb-3 font-[Merriweather,_serif]" data-id="element-54">
            1. Geltungsbereich
          </h2>
          <p className="font-['Open_Sans',_sans-serif] text-[15px] text-gray-700" data-id="element-55">
            Diese Nutzungsbedingungen regeln die Nutzung der von Emerald Health
            Solutions Ltd. (nachfolgend „Anbieter") bereitgestellten
            Informationswebsite. Durch den Zugriff auf diese Website erklären
            Sie sich mit diesen Bedingungen einverstanden.
          </p>
        </section>

        <section data-id="element-56">
          <h2 className="text-xl font-bold text-brand-navy mb-3 font-[Merriweather,_serif]" data-id="element-57">
            2. Geistiges Eigentum und Urheberrecht
          </h2>
          <p className="font-['Open_Sans',_sans-serif] text-[15px] text-gray-700 mb-4" data-id="element-58">
            Die auf dieser Website veröffentlichten Inhalte, Texte, Bilder und
            Grafiken unterliegen dem Urheberrecht. Jede Art der
            Vervielfältigung, Bearbeitung, Verbreitung und jede Art der
            Verwertung außerhalb der Grenzen des Urheberrechts bedarf der
            vorherigen schriftlichen Zustimmung des jeweiligen Urhebers bzw.
            Erstellers.
          </p>
          <p className="font-['Open_Sans',_sans-serif] text-[15px] text-gray-700" data-id="element-59">
            Downloads und Kopien dieser Seite sind nur für den privaten, nicht
            kommerziellen Gebrauch gestattet.
          </p>
        </section>

        <section data-id="element-60">
          <h2 className="text-xl font-bold text-brand-navy mb-3 font-[Merriweather,_serif]" data-id="element-61">
            3. Haftungsbeschränkung
          </h2>
          <p className="font-['Open_Sans',_sans-serif] text-[15px] text-gray-700 mb-4" data-id="element-62">
            Die Inhalte dieser Website werden mit größtmöglicher Sorgfalt
            erstellt. Der Anbieter übernimmt jedoch keine Gewähr für die
            Richtigkeit, Vollständigkeit und Aktualität der bereitgestellten
            Inhalte. Die Nutzung der abrufbaren Inhalte erfolgt auf eigene
            Gefahr des Nutzers.
          </p>
        </section>

        <section data-id="element-63">
          <h2 className="text-xl font-bold text-brand-navy mb-3 font-[Merriweather,_serif]" data-id="element-64">
            4. Externe Links
          </h2>
          <p className="font-['Open_Sans',_sans-serif] text-[15px] text-gray-700 mb-4" data-id="element-65">
            Diese Website enthält Verknüpfungen zu Websites Dritter („externe
            Links"). Diese Websites unterliegen der Haftung der jeweiligen
            Betreiber. Der Anbieter hat bei der erstmaligen Verknüpfung der
            externen Links die fremden Inhalte daraufhin überprüft, ob etwaige
            Rechtsverstöße bestehen. Zu dem Zeitpunkt waren keine Rechtsverstöße
            ersichtlich.
          </p>
        </section>

        <section data-id="element-66">
          <h2 className="text-xl font-bold text-brand-navy mb-3 font-[Merriweather,_serif]" data-id="element-67">
            5. Änderungen der Nutzungsbedingungen
          </h2>
          <p className="font-['Open_Sans',_sans-serif] text-[15px] text-gray-700" data-id="element-68">
            Der Anbieter behält sich das Recht vor, diese Nutzungsbedingungen
            jederzeit zu ändern. Die geänderten Bedingungen werden auf der
            Website veröffentlicht.
          </p>
        </section>

        <section data-id="element-69">
          <h2 className="text-xl font-bold text-brand-navy mb-3 font-[Merriweather,_serif]" data-id="element-70">
            6. Anwendbares Recht
          </h2>
          <p className="font-['Open_Sans',_sans-serif] text-[15px] text-gray-700" data-id="element-71">
            Es gilt das Recht der Republik Irland. Bei Verbrauchern gilt diese
            Rechtswahl nur insoweit, als nicht der gewährte Schutz durch
            zwingende Bestimmungen des Rechts des Staates, in dem der
            Verbraucher seinen gewöhnlichen Aufenthalt hat, entzogen wird.
          </p>
        </section>
      </div>
  },
  widerruf: {
    title: 'Haftungsausschluss',
    content: <div className="space-y-6" data-id="element-72">
        <section data-id="element-73">
          <h2 className="text-xl font-bold text-brand-navy mb-3 font-[Merriweather,_serif]" data-id="element-74">
            Medizinischer Hinweis
          </h2>
          <p className="font-['Open_Sans',_sans-serif] text-[15px] text-gray-700 mb-4" data-id="element-75">
            Die auf dieser Website bereitgestellten Informationen dienen
            ausschließlich der allgemeinen Information und ersetzen in keinem
            Fall eine professionelle medizinische Beratung, Diagnose oder
            Behandlung durch einen approbierten Arzt.
          </p>
          <p className="font-['Open_Sans',_sans-serif] text-[15px] text-gray-700 mb-4" data-id="element-76">
            Bitte suchen Sie bei gesundheitlichen Beschwerden oder Fragen immer
            einen Arzt oder anderes qualifiziertes medizinisches Fachpersonal
            auf. Ignorieren Sie niemals professionellen medizinischen Rat und
            zögern Sie nicht, diesen einzuholen, aufgrund von Informationen, die
            Sie auf dieser Website gelesen haben.
          </p>
        </section>

        <section data-id="element-77">
          <h2 className="text-xl font-bold text-brand-navy mb-3 font-[Merriweather,_serif]" data-id="element-78">
            Haftung für Inhalte
          </h2>
          <p className="font-['Open_Sans',_sans-serif] text-[15px] text-gray-700 mb-4" data-id="element-79">
            Als Diensteanbieter sind wir für eigene Inhalte auf diesen Seiten
            nach den allgemeinen Gesetzen verantwortlich. Wir sind jedoch nicht
            verpflichtet, übermittelte oder gespeicherte fremde Informationen zu
            überwachen oder nach Umständen zu forschen, die auf eine
            rechtswidrige Tätigkeit hinweisen.
          </p>
          <p className="font-['Open_Sans',_sans-serif] text-[15px] text-gray-700 mb-4" data-id="element-80">
            Verpflichtungen zur Entfernung oder Sperrung der Nutzung von
            Informationen nach den allgemeinen Gesetzen bleiben hiervon
            unberührt. Eine diesbezügliche Haftung ist jedoch erst ab dem
            Zeitpunkt der Kenntnis einer konkreten Rechtsverletzung möglich. Bei
            Bekanntwerden von entsprechenden Rechtsverletzungen werden wir diese
            Inhalte umgehend entfernen.
          </p>
        </section>

        <section data-id="element-81">
          <h2 className="text-xl font-bold text-brand-navy mb-3 font-[Merriweather,_serif]" data-id="element-82">
            Haftung für Links
          </h2>
          <p className="font-['Open_Sans',_sans-serif] text-[15px] text-gray-700 mb-4" data-id="element-83">
            Unser Angebot enthält Links zu externen Websites Dritter, auf deren
            Inhalte wir keinen Einfluss haben. Deshalb können wir für diese
            fremden Inhalte auch keine Gewähr übernehmen. Für die Inhalte der
            verlinkten Seiten ist stets der jeweilige Anbieter oder Betreiber
            der Seiten verantwortlich.
          </p>
          <p className="font-['Open_Sans',_sans-serif] text-[15px] text-gray-700" data-id="element-84">
            Die verlinkten Seiten wurden zum Zeitpunkt der Verlinkung auf
            mögliche Rechtsverstöße überprüft. Rechtswidrige Inhalte waren zum
            Zeitpunkt der Verlinkung nicht erkennbar. Eine permanente
            inhaltliche Kontrolle der verlinkten Seiten ist jedoch ohne konkrete
            Anhaltspunkte einer Rechtsverletzung nicht zumutbar. Bei
            Bekanntwerden von Rechtsverletzungen werden wir derartige Links
            umgehend entfernen.
          </p>
        </section>

        <section data-id="element-85">
          <h2 className="text-xl font-bold text-brand-navy mb-3 font-[Merriweather,_serif]" data-id="element-86">
            Urheberrecht
          </h2>
          <p className="font-['Open_Sans',_sans-serif] text-[15px] text-gray-700" data-id="element-87">
            Die durch die Seitenbetreiber erstellten Inhalte und Werke auf
            diesen Seiten unterliegen dem Urheberrecht. Die Vervielfältigung,
            Bearbeitung, Verbreitung und jede Art der Verwertung außerhalb der
            Grenzen des Urheberrechtes bedürfen der schriftlichen Zustimmung des
            jeweiligen Autors bzw. Erstellers. Soweit die Inhalte auf dieser
            Seite nicht vom Betreiber erstellt wurden, werden die Urheberrechte
            Dritter beachtet. Insbesondere werden Inhalte Dritter als solche
            gekennzeichnet.
          </p>
        </section>
      </div>
  },
  cookie: {
    title: 'Cookie-Richtlinie',
    content: <div className="space-y-6" data-id="element-88">
        <section data-id="element-89">
          <h2 className="text-xl font-bold text-brand-navy mb-3 font-[Merriweather,_serif]" data-id="element-90">
            Was sind Cookies?
          </h2>
          <p className="font-['Open_Sans',_sans-serif] text-[15px] text-gray-700" data-id="element-91">
            Cookies sind kleine Textdateien, die von Ihrem Browser auf Ihrem
            Endgerät zur Speicherung von bestimmten Informationen abgelegt
            werden. Durch die gespeicherten und zurückgesandten Informationen
            erkennt die jeweilige Website, dass Sie diese mit dem Browser Ihres
            Endgeräts bereits aufgerufen und besucht haben. Diese Informationen
            nutzen wir, um Ihnen die Website gemäß Ihren Präferenzen optimal
            gestalten und anzeigen zu können.
          </p>
        </section>

        <section data-id="element-92">
          <h2 className="text-xl font-bold text-brand-navy mb-3 font-[Merriweather,_serif]" data-id="element-93">
            Welche Cookies verwenden wir?
          </h2>

          <h3 className="text-lg font-semibold text-brand-navy mb-2 font-[Merriweather,_serif] mt-4" data-id="element-94">
            Notwendige Cookies
          </h3>
          <p className="font-['Open_Sans',_sans-serif] text-[15px] text-gray-700 mb-4" data-id="element-95">
            Diese Cookies sind für den Betrieb der Website unbedingt
            erforderlich und ermöglichen beispielsweise sicherheitsrelevante
            Funktionalitäten. Ohne diese Cookies können bestimmte Dienste nicht
            bereitgestellt werden. Zu den notwendigen Cookies gehören:
          </p>
          <ul className="list-disc list-inside space-y-2 font-['Open_Sans',_sans-serif] text-[15px] text-gray-700 mb-4" data-id="element-96">
            <li data-id="element-97">Session-Cookies zur Aufrechterhaltung Ihrer Sitzung</li>
            <li data-id="element-98">
              Cookie-Consent-Cookies zur Speicherung Ihrer Cookie-Einstellungen
            </li>
            <li data-id="element-99">Sicherheits-Cookies zum Schutz vor Missbrauch</li>
          </ul>

          <h3 className="text-lg font-semibold text-brand-navy mb-2 font-[Merriweather,_serif] mt-4" data-id="element-100">
            Funktionale Cookies
          </h3>
          <p className="font-['Open_Sans',_sans-serif] text-[15px] text-gray-700 mb-4" data-id="element-101">
            Diese Cookies ermöglichen es der Website, erweiterte Funktionalität
            und Personalisierung bereitzustellen. Sie können von uns oder von
            Drittanbietern gesetzt werden, deren Dienste wir auf unseren Seiten
            verwenden. Funktionale Cookies umfassen:
          </p>
          <ul className="list-disc list-inside space-y-2 font-['Open_Sans',_sans-serif] text-[15px] text-gray-700 mb-4" data-id="element-102">
            <li data-id="element-103">Cookies zur Speicherung Ihrer Sprachpräferenz</li>
            <li data-id="element-104">Cookies zur Speicherung von Formularinhalten</li>
            <li data-id="element-105">Cookies für personalisierte Inhalte</li>
          </ul>

          <h3 className="text-lg font-semibold text-brand-navy mb-2 font-[Merriweather,_serif] mt-4" data-id="element-106">
            Analyse-Cookies
          </h3>
          <p className="font-['Open_Sans',_sans-serif] text-[15px] text-gray-700 mb-4" data-id="element-107">
            Diese Cookies sammeln Informationen darüber, wie Besucher unsere
            Website nutzen. Alle Informationen, die diese Cookies sammeln, sind
            aggregiert und daher anonymisiert. Wir verwenden diese Informationen
            nur zur Verbesserung der Funktionsweise unserer Website.
            Analyse-Cookies beinhalten:
          </p>
          <ul className="list-disc list-inside space-y-2 font-['Open_Sans',_sans-serif] text-[15px] text-gray-700 mb-4" data-id="element-108">
            <li data-id="element-109">Google Analytics zur Analyse des Nutzerverhaltens</li>
            <li data-id="element-110">Heatmap-Tools zur Optimierung der Benutzerführung</li>
            <li data-id="element-111">A/B-Testing-Tools zur Verbesserung der Website</li>
          </ul>

          <h3 className="text-lg font-semibold text-brand-navy mb-2 font-[Merriweather,_serif] mt-4" data-id="element-112">
            Marketing-Cookies
          </h3>
          <p className="font-['Open_Sans',_sans-serif] text-[15px] text-gray-700" data-id="element-113">
            Diese Cookies werden verwendet, um Besuchern auf Webseiten zu
            folgen. Die Absicht ist, Anzeigen zu zeigen, die relevant und
            ansprechend für den einzelnen Benutzer sind und daher wertvoller für
            Publisher und werbetreibende Drittparteien sind. Marketing-Cookies
            können von uns oder von Drittanbietern in unserem Auftrag gesetzt
            werden.
          </p>
        </section>

        <section data-id="element-114">
          <h2 className="text-xl font-bold text-brand-navy mb-3 font-[Merriweather,_serif]" data-id="element-115">
            Wie können Sie Cookies verwalten?
          </h2>
          <p className="font-['Open_Sans',_sans-serif] text-[15px] text-gray-700 mb-4" data-id="element-116">
            Sie können Ihre Cookie-Einstellungen jederzeit ändern, indem Sie auf
            den Link „Cookie-Einstellungen" am Ende dieser Seite klicken. Dort
            können Sie Ihre Zustimmung widerrufen oder Ihre Präferenzen
            anpassen.
          </p>
          <p className="font-['Open_Sans',_sans-serif] text-[15px] text-gray-700 mb-4" data-id="element-117">
            Darüber hinaus können Sie in Ihrem Browser Einstellungen vornehmen,
            um Cookies zu blockieren oder zu löschen. Bitte beachten Sie, dass
            die Deaktivierung von Cookies die Funktionalität unserer Website
            beeinträchtigen kann.
          </p>
        </section>

        <section data-id="element-118">
          <h2 className="text-xl font-bold text-brand-navy mb-3 font-[Merriweather,_serif]" data-id="element-119">
            Cookie-Speicherdauer
          </h2>
          <p className="font-['Open_Sans',_sans-serif] text-[15px] text-gray-700" data-id="element-120">
            Session-Cookies werden automatisch gelöscht, wenn Sie Ihren Browser
            schließen. Permanente Cookies bleiben auf Ihrem Gerät gespeichert,
            bis sie ablaufen oder Sie diese manuell löschen. Die Speicherdauer
            der einzelnen Cookies können Sie den Informationen in Ihrem Browser
            entnehmen.
          </p>
        </section>

        <section data-id="element-121">
          <h2 className="text-xl font-bold text-brand-navy mb-3 font-[Merriweather,_serif]" data-id="element-122">
            Kontakt
          </h2>
          <p className="font-['Open_Sans',_sans-serif] text-[15px] text-gray-700" data-id="element-123">
            Bei Fragen zu unserer Cookie-Richtlinie können Sie uns jederzeit
            unter contact@emerald-health.ie kontaktieren.
          </p>
        </section>
      </div>
  }
};
export function App() {
  const [activeModal, setActiveModal] = useState<LegalPage>(null);
  const [showCookieBanner, setShowCookieBanner] = useState(false);
  const [showMoreComments, setShowMoreComments] = useState(false);
  useEffect(() => {
    // Load Google Fonts asynchronously to avoid render-blocking
    const link = document.createElement('link');
    link.rel = 'stylesheet';
    link.href = 'https://fonts.googleapis.com/css2?family=Open+Sans:wght@400;600;700&display=swap';
    link.media = 'print';
    link.onload = () => {
      link.media = 'all';
    };
    document.head.appendChild(link);
    // Preconnect to Google Fonts for faster font file download
    const preconnect = document.createElement('link');
    preconnect.rel = 'preconnect';
    preconnect.href = 'https://fonts.gstatic.com';
    preconnect.crossOrigin = 'anonymous';
    document.head.appendChild(preconnect);
    // Check if user has already made a cookie choice
    const cookieConsent = localStorage.getItem('cookie-consent');
    if (!cookieConsent) {
      setShowCookieBanner(true);
    }
  }, []);
  const handleCookieConsent = (type: 'all' | 'necessary') => {
    localStorage.setItem('cookie-consent', type);
    setShowCookieBanner(false);
  };
  const openModal = (page: Exclude<LegalPage, null>) => {
    setActiveModal(page);
    document.body.style.overflow = 'hidden';
  };
  const closeModal = () => {
    setActiveModal(null);
    document.body.style.overflow = 'unset';
  };
  return <Routes data-id="element-124">
      <Route path="/erfahrungsberichte/klaus-schlaf-report" element={<ArticlePage activeModal={activeModal} showCookieBanner={showCookieBanner} showMoreComments={showMoreComments} setShowMoreComments={setShowMoreComments} openModal={openModal} closeModal={closeModal} handleCookieConsent={handleCookieConsent} data-id="element-126" />} data-id="element-125" />
      <Route path="*" element={<Navigate to="/erfahrungsberichte/klaus-schlaf-report" replace data-id="element-128" />} data-id="element-127" />
    </Routes>;
}
function ArticlePage({
  activeModal,
  showCookieBanner,
  showMoreComments,
  setShowMoreComments,
  openModal,
  closeModal,
  handleCookieConsent
}: {
  activeModal: LegalPage;
  showCookieBanner: boolean;
  showMoreComments: boolean;
  setShowMoreComments: (v: boolean) => void;
  openModal: (page: Exclude<LegalPage, null>) => void;
  closeModal: () => void;
  handleCookieConsent: (type: 'all' | 'necessary') => void;
}) {
  const [userComments, setUserComments] = useState<{
    id: number;
    text: string;
    name: string;
    time: string;
  }[]>([]);
  const [commentText, setCommentText] = useState('');
  const [commentName, setCommentName] = useState('');
  const handleSubmitComment = () => {
    const trimmed = commentText.trim();
    if (!trimmed) return;
    setUserComments(prev => [...prev, {
      id: Date.now(),
      text: trimmed,
      name: commentName.trim() || 'Anonym',
      time: 'gerade eben'
    }]);
    setCommentText('');
  };
  return <div className="min-h-screen bg-brand-bg font-lora selection:bg-brand-gold/20" data-id="element-129">
      {/* Top Navigation Bar */}
      <header className="border-b border-gray-200 bg-[#F4F1EB]" data-id="element-130">
        {/* Top utility bar */}
        <div className="border-b border-gray-100 py-1.5" data-id="element-131">
          <div className="max-w-4xl mx-auto px-4 flex justify-center items-center text-[9px] sm:text-[10px] tracking-[0.15em] uppercase font-['Open_Sans',_sans-serif]" data-id="element-132">
            <span className="text-[#4A4A4A]" data-id="element-133">Anzeige</span>
            <span className="mx-2 sm:mx-3 text-gray-200" data-id="element-134">|</span>
            <span className="font-bold text-[#2c4364]" data-id="element-135">Erfahrungsbericht</span>
            <span className="mx-2 sm:mx-3 text-gray-200" data-id="element-136">|</span>
            <span className="text-[#4A4A4A]" data-id="element-137">April 2026</span>
          </div>
        </div>
        {/* Main magazine masthead */}
        <div className="max-w-4xl mx-auto px-4 py-8 sm:py-10 md:py-12 flex flex-col items-center bg-[#2C4364]" data-id="element-138">
          <div className="text-center" data-id="element-139">
            <h1 className="text-2xl sm:text-3xl md:text-4xl font-bold font-[Merriweather,_serif] tracking-tight text-[#F5F1EA]" data-id="element-140">
              Vital-Wegweiser
            </h1>
            <p className="text-xs sm:text-sm md:text-base font-['Open_Sans',_sans-serif] mt-1 sm:mt-2 tracking-wide text-[#F5F1EA]" data-id="element-141">
              Ihr Ratgeber für Gesundheit &amp; Wohlbefinden
            </p>
          </div>
        </div>
        {/* Category navigation */}
        <div className="border-t border-gray-100" data-id="element-142">
          <nav className="max-w-4xl mx-auto px-4 flex items-center justify-center gap-6 sm:gap-10 py-2.5 text-[10px] sm:text-[11px] uppercase tracking-[0.15em] font-semibold font-['Open_Sans',_sans-serif] text-gray-400" data-id="element-143">
            <span className="text-[#2c4364] border-b-2 border-[#d4a338] pb-0.5" data-id="element-144">
              Gesundheit
            </span>
            <span className="hover:text-[#2c4364] transition-colors cursor-pointer" data-id="element-145">
              Schlaf
            </span>
            <span className="hover:text-[#2c4364] transition-colors cursor-pointer" data-id="element-146">
              Ernährung
            </span>
            <span className="hover:text-[#2c4364] transition-colors cursor-pointer" data-id="element-147">
              Fitness
            </span>
          </nav>
        </div>
      </header>

      {/* Main Content Area */}
      <main className="max-w-[640px] mx-auto px-6 sm:px-6 pt-8 sm:pt-12 pb-20" data-id="element-148">
        {/* Badge */}
        <div className="inline-flex items-center gap-2 border border-brand-gold bg-[#fdf8e8] rounded-lg px-5 py-2.5 mb-5 sm:mb-7" data-id="element-149">
          <PenLine className="w-4 h-4 text-brand-gold" strokeWidth={2} data-id="element-150" />
          <span className="text-[11px] sm:text-[12px] font-bold text-brand-gold uppercase tracking-[0.15em]" data-id="element-151">
            Erfahrungsbericht
          </span>
        </div>

        {/* Headline */}
        <h1 className="sm:text-[32px] md:text-[38px] font-bold mb-5 tracking-tight text-[24px] font-[Merriweather,_serif] text-[#2C4364]" data-id="element-152">
          Jede Nacht 3–4 Mal raus? Ich auch — 12 Jahre lang. Heute schlafe ich
          durch. Hier ist, was sich geändert hat.
        </h1>

        {/* Intro Paragraph */}
        <p className="sm:text-lg text-gray-600 mb-7 sm:mb-9 font-[400] font-['Open_Sans',_sans-serif] text-[15px]" data-id="element-153">
          54, Ingenieur aus Dortmund. Seit 12 Jahren stehe ich jede Nacht 3–4
          Mal auf, weil meine Blase drückt. Ich habe alles versucht — bis mir
          ein Kollege an einer Hotelbar etwas erzählt hat.
        </p>

        {/* Author Section */}
        <div className="flex items-center gap-3.5 mb-7" data-id="element-154">
          <img src="https://cdn.magicpatterns.com/uploads/qVc2QmLCfUGq2DkeFcv3D4/johan.webp" alt="Klaus M." className="w-16 h-16 sm:w-20 sm:h-20 rounded-full object-cover shadow-sm" width={80} height={80} decoding="async" fetchPriority="high" data-id="element-155" />
          <div data-id="element-156">
            <div className="font-bold text-gray-900 text-sm sm:text-base mb-0.5" data-id="element-157">
              Johan M.
            </div>
            <div className="text-[11px] sm:text-xs text-gray-500 flex flex-wrap items-center gap-1.5" data-id="element-158">
              <span className="font-[Merriweather,_serif] text-[15px]" data-id="element-159">
                54, Dortmund
              </span>
              <span className="hidden sm:inline" data-id="element-160">·</span>
              <span className="font-[Merriweather,_serif] text-[15px]" data-id="element-161">
                April 14, 2026
              </span>
              <span className="hidden sm:inline" data-id="element-162">·</span>
              <span className="flex items-center gap-1 font-[Merriweather,_serif] text-[15px]" data-id="element-163">
                <Clock className="w-3 h-3" data-id="element-164" /> 5 Min. Lesezeit
              </span>
              <span className="hidden sm:inline" data-id="element-165">·</span>
              <span className="flex items-center gap-1 font-[Merriweather,_serif] text-[15px] font-[500] text-[#6B7280]" data-id="element-166">
                <Eye className="w-3 h-3" data-id="element-167" /> 220.139 Aufrufe
              </span>
            </div>
          </div>
        </div>

        {/* Horizontal Divider */}
        <hr className="border-gray-200 mb-7 sm:mb-9" data-id="element-168" />

        {/* Blockquote */}
        <blockquote className="border-l-[3px] border-brand-gold pl-4 sm:pl-5 italic text-base sm:text-lg text-gray-600 leading-[1.65] mb-8 font-['Open_Sans',_sans-serif] font-[500]" data-id="element-169">
          Ich schreibe das hier, weil mir vor einem halben Jahr jemand einen
          Tipp gegeben hat, der mein Leben verändert hat. Vielleicht hilft es
          einem von euch genauso.
        </blockquote>

        {/* Body Text Paragraphs */}
        <div className="space-y-5 text-[15px] sm:text-base text-brand-body leading-[1.8]" data-id="element-170">
          <p className="font-['Open_Sans',_sans-serif] text-[15px]" data-id="element-171">
            Ich sage es direkt, weil jeder, der das hier liest, wahrscheinlich
            genau weiß, wovon ich rede:{' '}
            <strong className="font-bold text-brand-navy" data-id="element-172">
              Ich muss nachts ständig auf die Toilette.
            </strong>{' '}
            Drei Mal, vier Mal, manchmal fünf Mal. Seit über 12 Jahren. Jede
            einzelne Nacht.
          </p>
          <p className="font-['Open_Sans',_sans-serif] text-[15px]" data-id="element-173">
            Ich heiße Klaus, bin 54 Jahre alt, Maschinenbauingenieur bei einem
            mittelständischen Betrieb in Dortmund. Verheiratet, zwei erwachsene
            Kinder, eigentlich ein ganz normales Leben. Aber dieses nächtliche
            Aufstehen hat mich über die Jahre komplett zermürbt. Nicht der Gang
            zur Toilette selbst — sondern die Tatsache, dass{' '}
            <strong className="font-bold text-brand-navy" data-id="element-174">
              man danach nie wieder richtig in den Tiefschlaf kommt.
            </strong>{' '}
            Man döst nur noch. Und morgens fühlt man sich, als hätte man gar
            nicht geschlafen.
          </p>

          {/* NEW CONTENT STARTS HERE */}

          <div className="my-8" data-id="element-175">
            <img src="https://cdn.magicpatterns.com/uploads/2CDNcYKSrbq4TzZD3j7AFH/pasted-image.jpg" alt="Mann sitzt nachts frustriert auf dem Bett" className="w-full rounded-md shadow-sm mb-3" loading="lazy" decoding="async" data-id="element-176" />
            <p className="text-sm text-gray-500 italic font-['Open_Sans',_sans-serif]" data-id="element-177">
              So sahen meine Nächte aus — jede Nacht, jahrelang. (Symbolbild)
            </p>
          </div>

          <h2 className="text-brand-navy sm:text-2xl font-bold mt-10 mb-5 text-[18px] font-[Merriweather,_serif]" data-id="element-178">
            Wie alles angefangen hat
          </h2>

          <p className="font-['Open_Sans',_sans-serif] text-[15px]" data-id="element-179">
            Es fing schleichend an, Anfang 40. Erst einmal pro Nacht aufstehen.
            Kein Drama. Dann zweimal. Dann dreimal. Und irgendwann war ich bei
            vier Mal pro Nacht und wurde morgens um 6:00 vom Wecker geweckt,
            obwohl ich seit 3:30 eigentlich nur noch so lag — irgendwo zwischen
            wach und erledigt.
          </p>

          <p className="font-['Open_Sans',_sans-serif] text-[15px]" data-id="element-180">
            Meine Frau Sabine hat irgendwann angefangen, im Gästezimmer zu
            schlafen. Nicht weil wir Probleme hatten — sondern weil ich sie jede
            Nacht mitgeweckt habe. Das Aufstehen, das Licht im Flur, die
            Klospülung, das Zurückkommen, das Herumwälzen. Das war der Moment,
            in dem ich dachte:{' '}
            <strong className="font-bold text-brand-navy" data-id="element-181">
              So kann das nicht weitergehen.
            </strong>
          </p>

          <p className="font-['Open_Sans',_sans-serif] text-[15px]" data-id="element-182">
            Ich war beim Urologen. Prostata leicht vergrößert, nichts
            Dramatisches, „ganz normal in Ihrem Alter". PSA unauffällig. Alles
            im grünen Bereich — medizinisch gesehen. Aber medizinisch im grünen
            Bereich heißt nicht, dass man nachts durchschlafen kann. Der Arzt
            hat es so formuliert:{' '}
            <em className="italic" data-id="element-183">
              „Die Prostata drückt etwas auf die Blase, das kennen viele Männer
              ab 40. Leben Sie damit."
            </em>
          </p>

          <p className="font-['Open_Sans',_sans-serif] text-[15px]" data-id="element-184">
            Leben Sie damit. Super Ratschlag.
          </p>

          <h2 className="text-brand-navy sm:text-2xl font-bold mt-10 mb-5 text-[18px] font-[Merriweather,_serif]" data-id="element-185">
            Was ich alles ausprobiert habe (und was nichts gebracht hat)
          </h2>

          <p className="font-['Open_Sans',_sans-serif] text-[15px]" data-id="element-186">
            Ich bin Ingenieur. Ich gehe Probleme systematisch an. Also habe ich
            über die Jahre alles versucht, was das nächtliche Aufstehen
            reduzieren sollte. Hier meine Liste:
          </p>

          <ul className="space-y-4 my-6" data-id="element-187">
            <li className="flex gap-3" data-id="element-188">
              <X className="w-5 h-5 text-red-500 shrink-0 mt-1" data-id="element-189" />
              <div className="font-['Open_Sans',_sans-serif] text-[15px]" data-id="element-190">
                <strong className="font-bold text-brand-navy" data-id="element-191">
                  Ab 18 Uhr nichts mehr trinken
                </strong>{' '}
                — bringt wenig, wenn die Blase trotzdem Alarm schlägt. Und
                morgens war ich dehydriert.
              </div>
            </li>
            <li className="flex gap-3" data-id="element-192">
              <X className="w-5 h-5 text-red-500 shrink-0 mt-1" data-id="element-193" />
              <div className="font-['Open_Sans',_sans-serif] text-[15px]" data-id="element-194">
                <strong className="font-bold text-brand-navy" data-id="element-195">
                  Kürbiskern-Kapseln
                </strong>{' '}
                — habe ich monatelang genommen. Null Effekt auf die Nacht.
                Vielleicht Placebo für eine Woche.
              </div>
            </li>
            <li className="flex gap-3" data-id="element-196">
              <X className="w-5 h-5 text-red-500 shrink-0 mt-1" data-id="element-197" />
              <div className="font-['Open_Sans',_sans-serif] text-[15px]" data-id="element-198">
                <strong className="font-bold text-brand-navy" data-id="element-199">
                  Prostata-Tee aus der Apotheke
                </strong>{' '}
                — schmeckt furchtbar, hat nichts verändert.
              </div>
            </li>
            <li className="flex gap-3" data-id="element-200">
              <Minus className="w-5 h-5 text-yellow-600 shrink-0 mt-1" data-id="element-201" />
              <div className="font-['Open_Sans',_sans-serif] text-[15px]" data-id="element-202">
                <strong className="font-bold text-brand-navy" data-id="element-203">
                  Sägepalme-Kapseln aus dem Internet
                </strong>{' '}
                — drei verschiedene Marken ausprobiert, jeweils 2 Kapseln am Tag
                wie auf der Packung steht. Kein Unterschied. Irgendwann habe ich
                aus Frust einfach 5 Stück am Tag genommen — und tatsächlich,
                nach ein paar Wochen wurde es etwas besser. Vielleicht 1x
                weniger aufgestanden pro Nacht. Aber 5 Kapseln am Tag, das waren
                drei Packungen im Monat, fast 100 Euro, und trotzdem nur eine
                leichte Verbesserung. Irgendwann habe ich es gelassen.
              </div>
            </li>
            <li className="flex gap-3" data-id="element-204">
              <X className="w-5 h-5 text-red-500 shrink-0 mt-1" data-id="element-205" />
              <div className="font-['Open_Sans',_sans-serif] text-[15px]" data-id="element-206">
                <strong className="font-bold text-brand-navy" data-id="element-207">
                  Beckenboden-Training
                </strong>{' '}
                — ja, das gibt es auch für Männer. Habe ich 6 Wochen gemacht.
                Kein messbarer Unterschied nachts.
              </div>
            </li>
            <li className="flex gap-3" data-id="element-208">
              <Minus className="w-5 h-5 text-yellow-600 shrink-0 mt-1" data-id="element-209" />
              <div className="font-['Open_Sans',_sans-serif] text-[15px]" data-id="element-210">
                <strong className="font-bold text-brand-navy" data-id="element-211">
                  Kein Kaffee, kein Alkohol abends
                </strong>{' '}
                — hat die Situation vielleicht 10% verbessert. Statt 4x
                aufstehen: 3–4x. Toll.
              </div>
            </li>
          </ul>

          <p className="font-['Open_Sans',_sans-serif] text-[15px]" data-id="element-212">
            Wisst ihr, was das Frustrierendste war? Ich wusste genau, was los
            ist. Jeder Mann ab 40 weiß das. Die Blase. Die Prostata. Das
            Übliche.{' '}
            <strong className="font-bold text-brand-navy" data-id="element-213">
              Aber nichts, was ich ausprobiert habe, hat an meiner Situation
              wirklich etwas geändert.
            </strong>{' '}
            Und irgendwann gewöhnt man sich dran. Man lebt halt damit. So wie
            der Urologe gesagt hat.
          </p>

          <h2 className="text-brand-navy sm:text-2xl font-bold mt-10 mb-5 text-[18px] font-[Merriweather,_serif]" data-id="element-214">
            Der Moment, der alles verändert hat
          </h2>

          <p className="font-['Open_Sans',_sans-serif] text-[15px]" data-id="element-215">
            Letzten Herbst war ich auf einem Ingenieurstreffen in München.
            Abends an der Hotelbar kam ich mit einem Kollegen ins Gespräch —
            Ralf, 58, aus Nürnberg. Wir redeten über Arbeit, über die Kinder,
            und irgendwann sagte er beiläufig:
          </p>

          <div className="bg-white p-5 sm:p-6 rounded-lg shadow-sm border border-gray-100 border-l-[3px] border-l-brand-gold my-6" data-id="element-216">
            <p className="italic text-brand-navy text-base sm:text-lg leading-relaxed mb-3 font-['Open_Sans',_sans-serif] font-[500]" data-id="element-217">
              „Ich schlafe seit drei Monaten wie ein Teenager. Durch. Sieben
              Stunden am Stück. Hätte ich mir vor einem Jahr nicht vorstellen
              können."
            </p>
            <p className="text-xs text-gray-500 font-['Open_Sans',_sans-serif]" data-id="element-218">
              — Ralf, 58, Nürnberg
            </p>
          </div>

          <p className="font-['Open_Sans',_sans-serif] text-[15px]" data-id="element-219">
            Ich habe ihn angeschaut und gedacht: Der verarscht mich. Sieben
            Stunden am Stück — mit dem Blasenproblem? Aber er war völlig ernst.
            Er sagte:{' '}
            <em className="italic" data-id="element-220">
              „Hatte genau dasselbe wie du. Drei, vier Mal pro Nacht. Prostata
              drückt auf die Blase, kennst du ja."
            </em>
          </p>

          <p className="font-['Open_Sans',_sans-serif] text-[15px]" data-id="element-221">
            Kannte ich. Natürlich kannte ich das. Und dann fragte ich ihn
            direkt:
          </p>

          <div className="bg-white p-5 sm:p-6 rounded-lg shadow-sm border border-gray-100 border-l-[3px] border-l-brand-gold my-6" data-id="element-222">
            <p className="italic text-brand-navy text-base sm:text-lg leading-relaxed font-['Open_Sans',_sans-serif] font-[500]" data-id="element-223">
              „Ralf, ich habe alles versucht. Kürbiskern, Prostata-Tee, kein
              Trinken ab sechs. Was zum Teufel nimmst du?"
            </p>
          </div>

          <p className="font-['Open_Sans',_sans-serif] text-[15px]" data-id="element-224">
            Er erzählte mir von einem Nahrungsergänzungsmittel, das er seit drei
            Monaten nimmt. Irgendwas Pflanzliches, nichts
            Verschreibungspflichtiges. Mehr wusste er selbst nicht — und es war
            ihm auch völlig egal. Er sagte wörtlich:{' '}
            <strong className="font-bold text-brand-navy" data-id="element-225">
              „Klaus, ich kann dir nicht sagen, was da genau drin ist. Ich weiß
              nur, dass ich seit drei Monaten durchschlafe. Und das reicht mir."
            </strong>
          </p>

          <p className="font-['Open_Sans',_sans-serif] text-[15px]" data-id="element-226">
            Das Mittel heißt{' '}
            <strong className="font-bold text-brand-navy" data-id="element-227">NachTon</strong>. Er
            zeigte mir die Webseite auf seinem Handy. Sah seriös aus, kein
            Wundermittel-Geschrei, keine Vorher-Nachher-Bilder. Deutsche
            Entwicklung, klare Zutatenliste, nichts Exotisches.
          </p>

          <p className="font-['Open_Sans',_sans-serif] text-[15px]" data-id="element-228">
            Ich war skeptisch. Natürlich war ich das. Ich hatte schon Kürbiskern
            monatelang genommen — nichts. Drei verschiedene Sägepalme-Produkte —
            kaum Wirkung, und das Bisschen, was sich tat, nur bei absurder
            Dosierung. Warum sollte ausgerechnet das hier anders sein? Aber Ralf
            ist ein nüchterner Typ, kein Esoteriker. Und er sagte:{' '}
            <em className="italic" data-id="element-229">
              „Bestell eine Packung. Gib ihm vier Wochen. Wenn sich nichts tut,
              hast du 40 Euro verloren. Wenn doch — hast du dein Leben zurück."
            </em>
          </p>

          <h2 className="text-brand-navy sm:text-2xl font-bold mt-10 mb-5 text-[18px] font-[Merriweather,_serif]" data-id="element-230">
            Meine ersten Wochen mit NachTon
          </h2>

          <div className="my-8" data-id="element-231">
            <a href="https://nachton.de/products/nachton?utm_source=facebook&utm_medium=paid&utm_campaign=nachton_de&utm_content=adv_johan_erfahrungsbericht" target="_blank" rel="noopener noreferrer" data-id="element-232">
              <img src="https://cdn.magicpatterns.com/uploads/7D2qXWpU2RW1GvUYnyapyj/nachton_bewertung.webp" alt="NachTon Verpackung — Nahrungsergänzungsmittel" className="w-full rounded-md shadow-sm mb-3 cursor-pointer" loading="lazy" decoding="async" data-id="element-233" />
            </a>
            <p className="text-sm text-gray-500 italic font-['Open_Sans',_sans-serif]" data-id="element-234">
              Kam in einem Tag an. Sieht seriös aus, macht Vertrauen.
            </p>
          </div>

          <div className="flex items-center gap-3 bg-white border border-gray-200 rounded-md p-3 my-6 shadow-sm" data-id="element-235">
            <span className="text-white text-[10px] font-bold px-2.5 py-1 rounded uppercase tracking-wider font-['Open_Sans',_sans-serif] bg-[#2C4364]" data-id="element-236">
              Woche 1–2
            </span>
            <span className="font-bold sm:text-base font-['Open_Sans',_sans-serif] text-[#1a1a1a] text-[15px]" data-id="element-237">
              Skepsis, aber erste kleine Veränderungen
            </span>
          </div>

          <p className="font-['Open_Sans',_sans-serif] text-[15px]" data-id="element-238">
            Die Kapseln kamen drei Tage nach der Bestellung. Unscheinbare
            Verpackung, saubere Zutatenliste. Ich nahm abends zwei Kapseln mit
            einem Glas Wasser, wie empfohlen.
          </p>

          <p className="font-['Open_Sans',_sans-serif] text-[15px]" data-id="element-239">
            Die ersten drei Nächte: kein Unterschied. Vier Mal aufgestanden, wie
            immer. Ich dachte schon: typisch, wieder Geld rausgeworfen. Aber ab
            Nacht vier oder fünf merkte ich etwas Merkwürdiges:{' '}
            <strong className="font-bold text-brand-navy" data-id="element-240">
              Ich wurde zwar wach, aber ich konnte liegen bleiben.
            </strong>{' '}
            Das kannte ich nicht. Normalerweise musste ich SOFORT raus. Jetzt
            lag ich da, dachte „hmm, geht eigentlich" — und bin wieder
            eingeschlafen. Statt vier Mal bin ich noch zweimal aufgestanden.
          </p>

          <p className="font-['Open_Sans',_sans-serif] text-[15px]" data-id="element-241">
            Klingt nach wenig. Aber wer jahrelang vier Mal pro Nacht rausmuss,
            für den ist „zweimal" schon ein anderes Leben.
          </p>

          <div className="flex items-center gap-3 bg-white border border-gray-200 rounded-md p-3 my-6 shadow-sm" data-id="element-242">
            <span className="text-white text-[10px] font-bold px-2.5 py-1 rounded uppercase tracking-wider font-['Open_Sans',_sans-serif] bg-[#2C4364]" data-id="element-243">
              Woche 3–4
            </span>
            <span className="font-bold sm:text-base font-['Open_Sans',_sans-serif] text-[#1a1a1a] text-[15px]" data-id="element-244">
              Der Durchbruch
            </span>
          </div>

          <p className="font-['Open_Sans',_sans-serif] text-[15px]" data-id="element-245">
            Ende der dritten Woche ist es passiert. Ich wachte morgens auf,
            schaute auf den Wecker —{' '}
            <strong className="font-bold text-brand-navy" data-id="element-246">6:14 Uhr</strong>. Und
            ich lag noch im Bett. Ich war die ganze Nacht nicht aufgestanden.
            Kein einziges Mal.
          </p>

          <p className="font-['Open_Sans',_sans-serif] text-[15px]" data-id="element-247">
            Ich lag da und habe fast gelacht. Ich weiß noch, wie ich dachte: So
            fühlt sich das also an. Ausgeschlafen. Wirklich ausgeschlafen. Mein
            Kopf war klar, meine Augen waren nicht geschwollen, und ich hatte
            Energie. Richtige Energie.
          </p>

          <p className="font-['Open_Sans',_sans-serif] text-[15px]" data-id="element-248">
            Sabine hat mich angeschaut und gesagt:{' '}
            <em className="italic" data-id="element-249">„Du siehst anders aus heute."</em> Und sie
            hatte recht.
          </p>

          <div className="flex items-center gap-3 bg-white border border-gray-200 rounded-md p-3 my-6 shadow-sm" data-id="element-250">
            <span className="text-white text-[10px] font-bold px-2.5 py-1 rounded uppercase tracking-wider font-['Open_Sans',_sans-serif] bg-[#2C4364]" data-id="element-251">
              Monat 2–6
            </span>
            <span className="font-bold sm:text-base font-['Open_Sans',_sans-serif] text-[#1a1a1a] text-[15px]" data-id="element-252">
              Die neue Normalität
            </span>
          </div>

          <p className="font-['Open_Sans',_sans-serif] text-[15px]" data-id="element-253">
            Ich nehme NachTon jetzt seit über sechs Monaten. Jeden Tag, zwei
            Kapseln. Es ist Teil meiner Routine geworden, wie Zähneputzen. Und
            ich kann euch sagen, was sich verändert hat:
          </p>

          <ul className="space-y-2.5 my-6" data-id="element-254">
            <li className="flex gap-3 items-start" data-id="element-255">
              <Check className="w-4.5 h-4.5 text-green-600 shrink-0 mt-0.5" data-id="element-256" />
              <span className="font-['Open_Sans',_sans-serif] text-[15px]" data-id="element-257">
                Ich schlafe 6–7 Stunden am Stück durch — fast jede Nacht
              </span>
            </li>
            <li className="flex gap-3 items-start" data-id="element-258">
              <Check className="w-4.5 h-4.5 text-green-600 shrink-0 mt-0.5" data-id="element-259" />
              <span className="font-['Open_Sans',_sans-serif] text-[15px]" data-id="element-260">
                Wenn ich mal aufstehe (vielleicht 1x pro Woche), schlafe ich
                sofort wieder ein
              </span>
            </li>
            <li className="flex gap-3 items-start" data-id="element-261">
              <Check className="w-4.5 h-4.5 text-green-600 shrink-0 mt-0.5" data-id="element-262" />
              <span className="font-['Open_Sans',_sans-serif] text-[15px]" data-id="element-263">
                Morgens wache ich wach auf — nicht erschlagen, nicht benebelt
              </span>
            </li>
            <li className="flex gap-3 items-start" data-id="element-264">
              <Check className="w-4.5 h-4.5 text-green-600 shrink-0 mt-0.5" data-id="element-265" />
              <span className="font-['Open_Sans',_sans-serif] text-[15px]" data-id="element-266">
                Meine Konzentration auf der Arbeit ist besser als seit 10 Jahren
              </span>
            </li>
            <li className="flex gap-3 items-start" data-id="element-267">
              <Check className="w-4.5 h-4.5 text-green-600 shrink-0 mt-0.5" data-id="element-268" />
              <span className="font-['Open_Sans',_sans-serif] text-[15px]" data-id="element-269">
                Sabine schläft wieder neben mir
              </span>
            </li>
          </ul>

          <div className="my-8" data-id="element-270">
            <img src="https://cdn.magicpatterns.com/uploads/sVTUpdSZ8HfaWvNhsMjfcG/SwmOYyXmQ_eIvGoYYZOxu_BCwhs4z1.webp" alt="Mann schläft friedlich" className="w-full rounded-md shadow-sm mb-3" loading="lazy" decoding="async" data-id="element-271" />
            <p className="text-sm text-gray-500 italic font-['Open_Sans',_sans-serif]" data-id="element-272">
              So wache ich jetzt morgens auf — ausgeschlafen, erholt, zum ersten
              Mal seit Jahren. (Symbolbild)
            </p>
          </div>

          <h2 className="text-brand-navy sm:text-2xl font-bold mt-10 mb-5 text-[18px] font-[Merriweather,_serif]" data-id="element-273">
            Was ich niemandem erzählt hätte — und warum ich es jetzt tue
          </h2>

          <p className="font-['Open_Sans',_sans-serif] text-[15px]" data-id="element-274">
            Ich bin kein Mann, der seine Gesundheit im Internet bespricht. Außer
            Ralf weiß niemand davon — nicht meine Kollegen auf der Arbeit, nicht
            meine Kinder. Das ist nicht das Thema, das man beim Mittagessen
            anspricht. Aber als ich letzte Woche in einem anderen Forum gelesen
            habe, wie ein Mann (51, aus Hamburg) genau dieselben Probleme
            beschrieben hat — das nächtliche Aufwachen, die Müdigkeit, die
            Frustration — da wusste ich:{' '}
            <strong className="font-bold text-brand-navy" data-id="element-275">
              Ich muss das aufschreiben.
            </strong>
          </p>

          <p className="font-['Open_Sans',_sans-serif] text-[15px]" data-id="element-276">
            Nicht weil ich für irgendwen Werbung machen will. Sondern weil mir
            jemand vor sechs Monaten geholfen hat, indem er mir ehrlich von
            seiner Erfahrung erzählt hat. Und jetzt tue ich dasselbe.
          </p>

          <div className="bg-[#fdf9eb] border border-[#f0e6c8] rounded-lg p-5 sm:p-6 my-8" data-id="element-277">
            <div className="flex items-center gap-2 font-bold text-brand-navy sm:text-base mb-3 font-['Open_Sans',_sans-serif] text-[16px]" data-id="element-278">
              <Info className="w-4 h-4 text-brand-gold" data-id="element-279" />
              Mein ehrliches Fazit nach 6 Monaten
            </div>
            <div className="space-y-3 text-[14px] sm:text-[15px] leading-[1.75]" data-id="element-280">
              <p className="font-['Open_Sans',_sans-serif] text-[15px]" data-id="element-281">
                NachTon ist kein Wundermittel. Es hat nicht über Nacht
                funktioniert (Ironie beiseite). Bei mir hat es zwei bis drei
                Wochen gedauert, bis ich einen echten Unterschied gemerkt habe.
                Aber seitdem schlafe ich durch — fast jede Nacht, seit über
                sechs Monaten. Das hatte ich seit über einem Jahrzehnt nicht.
              </p>
              <p className="font-['Open_Sans',_sans-serif] text-[15px]" data-id="element-282">
                Es ist ein Nahrungsergänzungsmittel mit natürlichen
                Inhaltsstoffen, kein Medikament. Ich kann nicht erklären, warum
                es bei mir so gut funktioniert hat, während Kürbiskern und der
                ganze andere Kram nichts gebracht haben. Ich weiß nur: Meine
                Nächte haben sich komplett verändert. Und das zählt für mich.
              </p>
            </div>
          </div>

          <h2 className="text-brand-navy sm:text-2xl font-bold mt-10 mb-5 text-[18px] font-[Merriweather,_serif]" data-id="element-283">
            Für wen ist NachTon geeignet?
          </h2>

          <p className="font-['Open_Sans',_sans-serif] text-[15px]" data-id="element-284">
            Ich bin kein Arzt und will hier keine medizinischen Ratschläge
            geben. Aber aus meiner Erfahrung sage ich: Wenn du ein Mann über 40
            bist und folgendes kennst, dann probier es aus:
          </p>

          <ul className="space-y-2.5 my-6" data-id="element-285">
            <li className="flex gap-3 items-start" data-id="element-286">
              <ChevronRight className="w-5 h-5 text-brand-navy shrink-0 mt-1" data-id="element-287" />
              <span className="font-['Open_Sans',_sans-serif] text-[15px]" data-id="element-288">
                Du stehst nachts 2–5 Mal auf, weil deine Blase drückt
              </span>
            </li>
            <li className="flex gap-3 items-start" data-id="element-289">
              <ChevronRight className="w-5 h-5 text-brand-navy shrink-0 mt-1" data-id="element-290" />
              <span className="font-['Open_Sans',_sans-serif] text-[15px]" data-id="element-291">
                Du weißt, dass es die Prostata ist — aber „leben Sie damit" ist
                keine Antwort
              </span>
            </li>
            <li className="flex gap-3 items-start" data-id="element-292">
              <ChevronRight className="w-5 h-5 text-brand-navy shrink-0 mt-1" data-id="element-293" />
              <span className="font-['Open_Sans',_sans-serif] text-[15px]" data-id="element-294">
                Kürbiskern, Prostata-Tee, weniger trinken abends — alles schon
                probiert
              </span>
            </li>
            <li className="flex gap-3 items-start" data-id="element-295">
              <ChevronRight className="w-5 h-5 text-brand-navy shrink-0 mt-1" data-id="element-296" />
              <span className="font-['Open_Sans',_sans-serif] text-[15px]" data-id="element-297">
                Du suchst etwas Natürliches — kein Medikament, kein Rezept
              </span>
            </li>
            <li className="flex gap-3 items-start" data-id="element-298">
              <ChevronRight className="w-5 h-5 text-brand-navy shrink-0 mt-1" data-id="element-299" />
              <span className="font-['Open_Sans',_sans-serif] text-[15px]" data-id="element-300">
                Du willst einfach nur durchschlafen — ohne Chemie, ohne
                Nebenwirkungen
              </span>
            </li>
          </ul>

          <p className="font-['Open_Sans',_sans-serif] text-[15px]" data-id="element-301">
            Dann steckst du in genau derselben Situation wie ich vor sechs
            Monaten. Und dann könnte NachTon auch bei dir funktionieren.
          </p>

          <div className="rounded-xl p-6 sm:p-8 text-center my-10 shadow-lg bg-[#2C4364]" data-id="element-302">
            <h3 className="text-white sm:text-2xl font-bold mb-3 font-[Merriweather,_serif] text-[21px]" data-id="element-303">
              Ich habe NachTon hier bestellt
            </h3>
            <p className="text-gray-300 sm:text-base mb-6 font-['Open_Sans',_sans-serif] text-[15px]" data-id="element-304">
              Die offizielle Webseite mit allen Infos zu Inhaltsstoffen und
              Bestellung.
            </p>
            <a href="https://nachton.de/products/nachton?utm_source=facebook&utm_medium=paid&utm_campaign=nachton_de&utm_content=adv_johan_erfahrungsbericht" target="_blank" rel="noopener noreferrer" className="bg-[#d4a338] hover:bg-[#c2932e] transition-colors text-white font-bold py-3.5 px-7 rounded-md w-full sm:w-auto inline-flex items-center justify-center gap-2 shadow-md text-[16px] font-['Open_Sans',_sans-serif]" data-id="element-305">
              Zur offiziellen NachTon-Seite
              <ArrowUpRight className="w-5 h-5" data-id="element-306" />
            </a>
            <div className="text-gray-400 text-[10px] sm:text-xs mt-5 flex flex-wrap justify-center gap-x-3 gap-y-1" data-id="element-307">
              <span className="font-['Open_Sans',_sans-serif] text-[12px]" data-id="element-308">
                Lieferung innerhalb Deutschlands
              </span>
              <span className="hidden sm:inline" data-id="element-309">•</span>
              <span className="font-['Open_Sans',_sans-serif] text-[12px]" data-id="element-310">
                Natürliche Inhaltsstoffe
              </span>
              <span className="hidden sm:inline" data-id="element-311">•</span>
              <span className="font-['Open_Sans',_sans-serif] text-[12px]" data-id="element-312">
                Diskret verpackt
              </span>
            </div>
          </div>

          <hr className="border-gray-200 my-12" data-id="element-313" />

          <h2 className="text-brand-navy sm:text-2xl font-bold mb-5 text-[18px] font-[Merriweather,_serif]" data-id="element-314">
            Nachtrag: Was Sabine dazu sagt
          </h2>

          <p className="font-['Open_Sans',_sans-serif] text-[15px]" data-id="element-315">
            Meine Frau wollte, dass ich noch etwas anhänge. Sie sagt, der
            Unterschied sei nicht nur der Schlaf. Ich sei „wieder da". Weniger
            gereizt, mehr Geduld, bessere Laune. Wir machen wieder Sachen am
            Wochenende, weil ich nicht mehr jeden Samstag auf dem Sofa hänge und
            versuche, den fehlenden Schlaf nachzuholen.
          </p>

          <p className="font-['Open_Sans',_sans-serif]" data-id="element-316">
            Letzte Woche waren wir wandern im Sauerland. 14 Kilometer. Vor einem
            Jahr hätte ich nach 5 Kilometern aufgegeben. Nicht weil mein Körper
            nicht konnte — sondern weil mein Körper nie richtig ausgeruht war.
          </p>

          <p className="font-['Open_Sans',_sans-serif]" data-id="element-317">
            <strong className="font-bold text-brand-navy" data-id="element-318">
              Guter Schlaf verändert alles.
            </strong>{' '}
            Das klingt wie ein Kalenderspruch, aber es ist wahr. Und ich bin
            froh, dass ich nicht aufgehört habe zu suchen.
          </p>

          <p className="font-['Open_Sans',_sans-serif]" data-id="element-319">
            Falls ihr Fragen habt, schreibt sie in die Kommentare. Ich versuche
            zu antworten.
          </p>

          <p className="font-['Open_Sans',_sans-serif]" data-id="element-320">Schlaft gut.</p>

          <p className="italic mt-8 font-['Open_Sans',_sans-serif]" data-id="element-321">
            — Klaus M., Dortmund
          </p>

          <hr className="border-gray-200 my-12" data-id="element-322" />

          {/* Comments Section */}
          <div className="mt-10" data-id="element-323">
            <div className="flex items-center gap-3 mb-6" data-id="element-324">
              <h3 className="text-brand-navy text-xl font-bold font-[Merriweather,_serif]" data-id="element-325">
                Kommentare
              </h3>
              <span className="bg-brand-navy text-white text-xs font-bold w-6 h-6 flex items-center justify-center rounded-full font-[Merriweather,_serif]" data-id="element-326">
                {18 + userComments.length}
              </span>
            </div>

            {/* Comment Form */}
            <div className="bg-white border border-gray-200 rounded-lg p-4 sm:p-5 mb-6 shadow-sm" data-id="element-327">
              <div className="mb-3" data-id="element-328">
                <input type="text" placeholder="Ihr Name (optional)" value={commentName} onChange={e => setCommentName(e.target.value)} className="w-full sm:w-64 px-3 py-2 border border-gray-200 rounded-md text-sm font-['Open_Sans',_sans-serif] text-gray-700 placeholder-gray-400 focus:outline-none focus:border-[#2c4364] focus:ring-1 focus:ring-[#2c4364] mb-3" data-id="element-329" />
                <textarea placeholder="Schreiben Sie einen Kommentar..." value={commentText} onChange={e => setCommentText(e.target.value)} onKeyDown={e => {
                if (e.key === 'Enter' && !e.shiftKey) {
                  e.preventDefault();
                  handleSubmitComment();
                }
              }} rows={3} className="w-full px-3 py-2 border border-gray-200 rounded-md text-sm font-['Open_Sans',_sans-serif] text-gray-700 placeholder-gray-400 focus:outline-none focus:border-[#2c4364] focus:ring-1 focus:ring-[#2c4364] resize-none" data-id="element-330" />
              </div>
              <div className="flex justify-end" data-id="element-331">
                <button onClick={handleSubmitComment} disabled={!commentText.trim()} className="bg-[#2c4364] hover:bg-[#1e2f48] disabled:bg-gray-300 disabled:cursor-not-allowed text-white font-semibold text-sm px-5 py-2 rounded-md transition-colors font-['Open_Sans',_sans-serif] inline-flex items-center gap-2" data-id="element-332">
                  Kommentieren
                  <SendIcon className="w-3.5 h-3.5" data-id="element-333" />
                </button>
              </div>
            </div>

            {/* User Comments (only visible to the person who wrote them) */}
            {userComments.map(comment => <div key={comment.id} className="bg-white border border-gray-200 rounded-lg p-4 sm:p-5 mb-5 shadow-sm" data-id="element-334">
                <div className="flex items-center gap-3 mb-3" data-id="element-335">
                  <div className="w-8 h-8 bg-[#d4a338] text-white rounded-full flex items-center justify-center font-bold text-sm" data-id="element-336">
                    {comment.name.charAt(0).toUpperCase()}
                  </div>
                  <div data-id="element-337">
                    <div className="font-bold text-brand-navy text-sm" data-id="element-338">
                      {comment.name}
                    </div>
                    <div className="text-[10px] text-gray-500" data-id="element-339">
                      {comment.time}
                    </div>
                  </div>
                </div>
                <p className="text-[14px] sm:text-[15px] text-gray-700 leading-relaxed mb-3 font-[Inter,_sans-serif]" data-id="element-340">
                  {comment.text}
                </p>
                <div className="flex items-center gap-4 text-xs text-gray-500 font-medium" data-id="element-341">
                  <button className="flex items-center gap-1.5 hover:text-brand-navy transition-colors" data-id="element-342">
                    <ThumbsUp className="w-4 h-4" data-id="element-343" /> 0
                  </button>
                  <button className="flex items-center gap-1.5 hover:text-brand-navy transition-colors" data-id="element-344">
                    <MessageCircle className="w-4 h-4" data-id="element-345" /> Antworten
                  </button>
                </div>
              </div>)}

            {/* Comment 1 */}
            <div className="bg-white border border-gray-200 rounded-lg p-4 sm:p-5 mb-5 shadow-sm" data-id="element-346">
              <div className="flex items-center gap-3 mb-3" data-id="element-347">
                <div className="w-8 h-8 bg-brand-navy text-white rounded-full flex items-center justify-center font-bold text-sm" data-id="element-348">
                  J
                </div>
                <div data-id="element-349">
                  <div className="font-bold text-brand-navy text-sm" data-id="element-350">
                    JürgenHH
                  </div>
                  <div className="text-[10px] text-gray-500" data-id="element-351">vor 3 Tagen</div>
                </div>
              </div>
              <p className="text-[14px] sm:text-[15px] text-gray-700 leading-relaxed mb-3 font-[Inter,_sans-serif]" data-id="element-352">
                Naja, klingt für mich erstmal wie Werbung, ehrlich gesagt. Bin
                49, stehe jede Nacht 3x auf. Habe schon Kürbiskern,
                Cranberry-Kapseln und den ganzen Apotheken-Kram durch — null
                Effekt. Warum sollte ausgerechnet das hier anders sein? Was ist
                da drin, was die anderen nicht haben?
              </p>
              <div className="flex items-center gap-4 text-xs text-gray-500 font-medium" data-id="element-353">
                <button className="flex items-center gap-1.5 hover:text-brand-navy transition-colors" data-id="element-354">
                  <ThumbsUp className="w-4 h-4" data-id="element-355" /> 12
                </button>
                <button className="flex items-center gap-1.5 hover:text-brand-navy transition-colors" data-id="element-356">
                  <MessageCircle className="w-4 h-4" data-id="element-357" /> Antworten
                </button>
              </div>
            </div>

            {/* Author Reply */}
            <div className="bg-[#fdf9eb] border border-[#f0e6c8] rounded-lg p-4 sm:p-5 ml-4 sm:ml-10 shadow-sm relative" data-id="element-358">
              {/* Connector line */}
              <div className="absolute -left-6 sm:-left-12 top-10 w-6 sm:w-12 h-px bg-gray-200" data-id="element-359"></div>
              <div className="absolute -left-6 sm:-left-12 -top-10 w-px h-20 bg-gray-200" data-id="element-360"></div>

              <div className="flex items-center gap-2 mb-2" data-id="element-361">
                <CheckCircle2 className="w-3.5 h-3.5 text-brand-gold" data-id="element-362" />
                <span className="text-[10px] font-bold text-brand-gold uppercase tracking-wider" data-id="element-363">
                  Autor
                </span>
              </div>
              <p className="text-[14px] sm:text-[15px] text-gray-700 leading-relaxed font-[Inter,_sans-serif]" data-id="element-364">
                @JürgenHH Verstehe ich total. Hatte ich genauso — nach der
                fünften Kürbiskern-Packung ohne Ergebnis glaubt man an gar
                nichts mehr. Ich kann dir nur sagen, was bei MIR passiert ist:
                Nach 2–3 Wochen NachTon habe ich angefangen, durchzuschlafen.
                Warum das bei mir funktioniert hat und Kürbiskern nicht, kann
                ich dir nicht erklären. Schau dir die Webseite an, da stehen die
                Inhaltsstoffe. Ich kann nur von meiner Erfahrung berichten — und
                die ist nach 12 Jahren Schlafmangel ziemlich eindeutig.
              </p>
            </div>

            {/* Comment 2 */}
            <div className="bg-white border border-gray-200 rounded-lg p-4 sm:p-5 mt-5 mb-5 shadow-sm" data-id="element-365">
              <div className="flex items-center gap-3 mb-4" data-id="element-366">
                <div className="w-8 h-8 bg-brand-navy text-white rounded-full flex items-center justify-center font-bold text-sm" data-id="element-367">
                  t
                </div>
                <div data-id="element-368">
                  <div className="font-bold text-brand-navy text-sm" data-id="element-369">
                    tom_ffm68
                  </div>
                  <div className="text-[10px] text-gray-500" data-id="element-370">vor 2 Tagen</div>
                </div>
              </div>
              <div className="space-y-4 text-[14px] sm:text-[15px] text-gray-700 leading-relaxed mb-4 font-[Inter,_sans-serif]" data-id="element-371">
                <p data-id="element-372">
                  Bin jetzt in Woche 2, wollte kurz updaten. Die erste Woche
                  habe ich wirklich gar keinen Unterschied gemerkt und wollte
                  schon aufhören. Aber dann hab ich deinen Bericht nochmal
                  gelesen und mir gedacht, ok, gibst du ihm noch eine Chance.
                </p>
                <p data-id="element-373">
                  Seit gestern (Tag 11) bin ich nur EINMAL aufgewacht letzte
                  Nacht. Einmal! Sonst waren es 3–4 Mal. Kann natürlich Zufall
                  sein, aber ich bleibe dran. Melde mich in 2 Wochen nochmal.
                </p>
              </div>
              <hr className="border-gray-100 mb-3" data-id="element-374" />
              <div className="flex items-center gap-4 text-xs text-gray-500 font-medium" data-id="element-375">
                <button className="flex items-center gap-1.5 hover:text-brand-navy transition-colors" data-id="element-376">
                  <ThumbsUp className="w-4 h-4" data-id="element-377" /> 27
                </button>
                <button className="flex items-center gap-1.5 hover:text-brand-navy transition-colors" data-id="element-378">
                  <MessageCircle className="w-4 h-4" data-id="element-379" /> Antworten
                </button>
              </div>
            </div>

            {/* Comment 3 */}
            <div className="bg-white border border-gray-200 rounded-lg p-4 sm:p-5 mb-5 shadow-sm" data-id="element-380">
              <div className="flex items-center gap-3 mb-4" data-id="element-381">
                <div className="w-8 h-8 bg-brand-navy text-white rounded-full flex items-center justify-center font-bold text-sm" data-id="element-382">
                  M
                </div>
                <div data-id="element-383">
                  <div className="font-bold text-brand-navy text-sm" data-id="element-384">
                    MartinKoeln
                  </div>
                  <div className="text-[10px] text-gray-500" data-id="element-385">vor 1 Tag</div>
                </div>
              </div>
              <div className="space-y-4 text-[14px] sm:text-[15px] text-gray-700 leading-relaxed mb-4 font-[Inter,_sans-serif]" data-id="element-386">
                <p data-id="element-387">
                  Johan, DANKE für diesen Beitrag. Ich bin 56 und nehme NachTon
                  seit 4 Monaten. Bin über eine ähnliche Empfehlung drauf
                  gekommen. Kann alles bestätigen, was du schreibst.
                </p>
                <p data-id="element-388">
                  Das Verrückte ist: Mein Hausarzt hat mich letztens gefragt, ob
                  ich abgenommen hätte. Nein — ich schlafe nur endlich wieder
                  richtig. Guter Schlaf verändert das ganze Gesicht, die
                  Haltung, alles. Meine Frau sagt dasselbe wie deine Sabine: „Du
                  bist wieder du selbst."
                </p>
                <p data-id="element-389">
                  An alle, die noch zweifeln: Gebt dem Ding 3–4 Wochen. Nicht 3
                  Tage. 3–4 Wochen. Es lohnt sich.
                </p>
              </div>
              <hr className="border-gray-100 mb-3" data-id="element-390" />
              <div className="flex items-center gap-4 text-xs text-gray-500 font-medium" data-id="element-391">
                <button className="flex items-center gap-1.5 hover:text-brand-navy transition-colors" data-id="element-392">
                  <ThumbsUp className="w-4 h-4" data-id="element-393" /> 41
                </button>
                <button className="flex items-center gap-1.5 hover:text-brand-navy transition-colors" data-id="element-394">
                  <MessageCircle className="w-4 h-4" data-id="element-395" /> Antworten
                </button>
              </div>
            </div>

            {/* Show More Comments Button */}
            {!showMoreComments && <button onClick={() => setShowMoreComments(true)} className="w-full py-3.5 bg-white border border-gray-200 rounded-lg text-brand-navy font-semibold text-sm font-['Open_Sans',_sans-serif] hover:bg-gray-50 transition-colors flex items-center justify-center gap-2 shadow-sm mb-5" data-id="element-396">
                15 weitere Kommentare anzeigen
                <ChevronDown className="w-4 h-4" data-id="element-397" />
              </button>}

            {showMoreComments && <>
                {/* Comment 4 */}
                <div className="bg-white border border-gray-200 rounded-lg p-4 sm:p-5 mb-5 shadow-sm" data-id="element-398">
                  <div className="flex items-center gap-3 mb-4" data-id="element-399">
                    <div className="w-8 h-8 bg-brand-navy text-white rounded-full flex items-center justify-center font-bold text-sm" data-id="element-400">
                      d
                    </div>
                    <div data-id="element-401">
                      <div className="font-bold text-brand-navy text-sm" data-id="element-402">
                        der_peter61
                      </div>
                      <div className="text-[10px] text-gray-500" data-id="element-403">vor 1 Tag</div>
                    </div>
                  </div>
                  <p className="text-[14px] sm:text-[15px] text-gray-700 leading-relaxed mb-3 font-[Inter,_sans-serif]" data-id="element-404">
                    Bin 61, hatte dasselbe Problem seit fast 15 Jahren. Mein
                    Sohn hat mir den Link geschickt. Ich war mega skeptisch,
                    aber nach 3 Wochen NachTon stehe ich nur noch 1x pro Nacht
                    auf — manchmal gar nicht. Meine Frau denkt, ich übertreibe.
                    Tue ich nicht.
                  </p>
                  <div className="flex items-center gap-4 text-xs text-gray-500 font-medium" data-id="element-405">
                    <button className="flex items-center gap-1.5 hover:text-brand-navy transition-colors" data-id="element-406">
                      <ThumbsUp className="w-4 h-4" data-id="element-407" /> 33
                    </button>
                    <button className="flex items-center gap-1.5 hover:text-brand-navy transition-colors" data-id="element-408">
                      <MessageCircle className="w-4 h-4" data-id="element-409" /> Antworten
                    </button>
                  </div>
                </div>

                {/* Comment 5 */}
                <div className="bg-white border border-gray-200 rounded-lg p-4 sm:p-5 mb-5 shadow-sm" data-id="element-410">
                  <div className="flex items-center gap-3 mb-4" data-id="element-411">
                    <div className="w-8 h-8 bg-brand-navy text-white rounded-full flex items-center justify-center font-bold text-sm" data-id="element-412">
                      h
                    </div>
                    <div data-id="element-413">
                      <div className="font-bold text-brand-navy text-sm" data-id="element-414">
                        hg_muenchen
                      </div>
                      <div className="text-[10px] text-gray-500" data-id="element-415">vor 1 Tag</div>
                    </div>
                  </div>
                  <p className="text-[14px] sm:text-[15px] text-gray-700 leading-relaxed mb-3 font-[Inter,_sans-serif]" data-id="element-416">
                    Danke Johan, einfach nur danke. Habe seit 8 Jahren nicht
                    mehr durchgeschlafen. Bin jetzt in Woche 4 und es ist wie
                    ein neues Leben. Mein Arzt hat mich gefragt, was ich anders
                    mache — ich sehe wohl 10 Jahre jünger aus. 😅
                  </p>
                  <div className="flex items-center gap-4 text-xs text-gray-500 font-medium" data-id="element-417">
                    <button className="flex items-center gap-1.5 hover:text-brand-navy transition-colors" data-id="element-418">
                      <ThumbsUp className="w-4 h-4" data-id="element-419" /> 28
                    </button>
                    <button className="flex items-center gap-1.5 hover:text-brand-navy transition-colors" data-id="element-420">
                      <MessageCircle className="w-4 h-4" data-id="element-421" /> Antworten
                    </button>
                  </div>
                </div>

                {/* Comment 6 */}
                <div className="bg-white border border-gray-200 rounded-lg p-4 sm:p-5 mb-5 shadow-sm" data-id="element-422">
                  <div className="flex items-center gap-3 mb-4" data-id="element-423">
                    <div className="w-8 h-8 bg-brand-navy text-white rounded-full flex items-center justify-center font-bold text-sm" data-id="element-424">
                      W
                    </div>
                    <div data-id="element-425">
                      <div className="font-bold text-brand-navy text-sm" data-id="element-426">
                        Werner.D
                      </div>
                      <div className="text-[10px] text-gray-500" data-id="element-427">
                        vor 23 Stunden
                      </div>
                    </div>
                  </div>
                  <p className="text-[14px] sm:text-[15px] text-gray-700 leading-relaxed mb-3 font-[Inter,_sans-serif]" data-id="element-428">
                    Was mich überzeugt hat: die Zutatenliste. Sägepalme,
                    Brennnesselwurzel, Pygeum — aber in viel höherer Dosierung
                    als die Billig-Kapseln aus dem Drogeriemarkt. Dazu Piperin
                    für die Bioverfügbarkeit. Das ist durchdacht, nicht einfach
                    zusammengewürfelt.
                  </p>
                  <div className="flex items-center gap-4 text-xs text-gray-500 font-medium" data-id="element-429">
                    <button className="flex items-center gap-1.5 hover:text-brand-navy transition-colors" data-id="element-430">
                      <ThumbsUp className="w-4 h-4" data-id="element-431" /> 19
                    </button>
                    <button className="flex items-center gap-1.5 hover:text-brand-navy transition-colors" data-id="element-432">
                      <MessageCircle className="w-4 h-4" data-id="element-433" /> Antworten
                    </button>
                  </div>
                </div>

                {/* Comment 7 */}
                <div className="bg-white border border-gray-200 rounded-lg p-4 sm:p-5 mb-5 shadow-sm" data-id="element-434">
                  <div className="flex items-center gap-3 mb-4" data-id="element-435">
                    <div className="w-8 h-8 bg-brand-navy text-white rounded-full flex items-center justify-center font-bold text-sm" data-id="element-436">
                      r
                    </div>
                    <div data-id="element-437">
                      <div className="font-bold text-brand-navy text-sm" data-id="element-438">
                        rainsky49
                      </div>
                      <div className="text-[10px] text-gray-500" data-id="element-439">
                        vor 22 Stunden
                      </div>
                    </div>
                  </div>
                  <p className="text-[14px] sm:text-[15px] text-gray-700 leading-relaxed mb-3 font-[Inter,_sans-serif]" data-id="element-440">
                    Muss ehrlich sagen: Die erste Woche war ich enttäuscht. Null
                    Veränderung. Wollte schon aufhören. Aber meine Frau hat
                    gesagt „du hast 6 Jahre gewartet, warte noch 2 Wochen". Ab
                    Tag 12 wurde es besser. Jetzt Woche 6 — schlafe 6-7 Stunden
                    durch. Wahnsinn.
                  </p>
                  <div className="flex items-center gap-4 text-xs text-gray-500 font-medium" data-id="element-441">
                    <button className="flex items-center gap-1.5 hover:text-brand-navy transition-colors" data-id="element-442">
                      <ThumbsUp className="w-4 h-4" data-id="element-443" /> 35
                    </button>
                    <button className="flex items-center gap-1.5 hover:text-brand-navy transition-colors" data-id="element-444">
                      <MessageCircle className="w-4 h-4" data-id="element-445" /> Antworten
                    </button>
                  </div>
                </div>

                {/* Comment 8 */}

                {/* Author Reply to Stefan */}

                {/* Comment 9 */}
                <div className="bg-white border border-gray-200 rounded-lg p-4 sm:p-5 mb-5 shadow-sm" data-id="element-446">
                  <div className="flex items-center gap-3 mb-4" data-id="element-447">
                    <div className="w-8 h-8 bg-brand-navy text-white rounded-full flex items-center justify-center font-bold text-sm" data-id="element-448">
                      d
                    </div>
                    <div data-id="element-449">
                      <div className="font-bold text-brand-navy text-sm" data-id="element-450">
                        dk_technik
                      </div>
                      <div className="text-[10px] text-gray-500" data-id="element-451">
                        vor 18 Stunden
                      </div>
                    </div>
                  </div>
                  <p className="text-[14px] sm:text-[15px] text-gray-700 leading-relaxed mb-3 font-[Inter,_sans-serif]" data-id="element-452">
                    Habe mir die Inhaltsstoffe von meinem Apotheker anschauen
                    lassen. Er meinte, die Kombination aus Sägepalme +
                    Brennnessel + Piperin ist tatsächlich gut belegt in Studien.
                    Das Piperin erhöht die Aufnahme der anderen Wirkstoffe um
                    ein Vielfaches. Kein Hokuspokus, sondern Biochemie.
                  </p>
                  <div className="flex items-center gap-4 text-xs text-gray-500 font-medium" data-id="element-453">
                    <button className="flex items-center gap-1.5 hover:text-brand-navy transition-colors" data-id="element-454">
                      <ThumbsUp className="w-4 h-4" data-id="element-455" /> 44
                    </button>
                    <button className="flex items-center gap-1.5 hover:text-brand-navy transition-colors" data-id="element-456">
                      <MessageCircle className="w-4 h-4" data-id="element-457" /> Antworten
                    </button>
                  </div>
                </div>

                {/* Comment 10 */}
                <div className="bg-white border border-gray-200 rounded-lg p-4 sm:p-5 mb-5 shadow-sm" data-id="element-458">
                  <div className="flex items-center gap-3 mb-4" data-id="element-459">
                    <div className="w-8 h-8 bg-brand-navy text-white rounded-full flex items-center justify-center font-bold text-sm" data-id="element-460">
                      F
                    </div>
                    <div data-id="element-461">
                      <div className="font-bold text-brand-navy text-sm" data-id="element-462">
                        FrankHH52
                      </div>
                      <div className="text-[10px] text-gray-500" data-id="element-463">
                        vor 16 Stunden
                      </div>
                    </div>
                  </div>
                  <p className="text-[14px] sm:text-[15px] text-gray-700 leading-relaxed mb-3 font-[Inter,_sans-serif]" data-id="element-464">
                    52 Jahre, gleiches Problem. Habe den Beitrag meiner Frau
                    gezeigt und sie hat sofort bestellt. 😂 Bin jetzt in Tag 8,
                    noch kein großer Unterschied, aber ich bleibe dran. Die
                    Erfahrungen hier machen Hoffnung.
                  </p>
                  <div className="flex items-center gap-4 text-xs text-gray-500 font-medium" data-id="element-465">
                    <button className="flex items-center gap-1.5 hover:text-brand-navy transition-colors" data-id="element-466">
                      <ThumbsUp className="w-4 h-4" data-id="element-467" /> 14
                    </button>
                    <button className="flex items-center gap-1.5 hover:text-brand-navy transition-colors" data-id="element-468">
                      <MessageCircle className="w-4 h-4" data-id="element-469" /> Antworten
                    </button>
                  </div>
                </div>

                {/* Comment 11 */}

                {/* Comment 12 */}
                <div className="bg-white border border-gray-200 rounded-lg p-4 sm:p-5 mb-5 shadow-sm" data-id="element-470">
                  <div className="flex items-center gap-3 mb-4" data-id="element-471">
                    <div className="w-8 h-8 bg-brand-navy text-white rounded-full flex items-center justify-center font-bold text-sm" data-id="element-472">
                      A
                    </div>
                    <div data-id="element-473">
                      <div className="font-bold text-brand-navy text-sm" data-id="element-474">
                        ApothekerUwe
                      </div>
                      <div className="text-[10px] text-gray-500" data-id="element-475">
                        vor 12 Stunden
                      </div>
                    </div>
                  </div>
                  <p className="text-[14px] sm:text-[15px] text-gray-700 leading-relaxed mb-3 font-[Inter,_sans-serif]" data-id="element-476">
                    Ich bin Apotheker und möchte kurz etwas zu einem bestimmten
                    Inhaltsstoff sagen: NachTon enthält Pygeum africanum — und
                    das ist tatsächlich selten. In den meisten
                    Prostata-Präparaten aus der Drogerie sucht man es
                    vergeblich. Dabei ist genau dieser Wirkstoff derjenige, der
                    klinisch am besten belegt ist, wenn es um nächtlichen
                    Harndrang geht. Wer nachts 2–3 Mal aufsteht und bisher
                    keinen Erfolg mit anderen Mitteln hatte — das könnte der
                    Grund sein.
                  </p>
                  <div className="flex items-center gap-4 text-xs text-gray-500 font-medium" data-id="element-477">
                    <button className="flex items-center gap-1.5 hover:text-brand-navy transition-colors" data-id="element-478">
                      <ThumbsUp className="w-4 h-4" data-id="element-479" /> 67
                    </button>
                    <button className="flex items-center gap-1.5 hover:text-brand-navy transition-colors" data-id="element-480">
                      <MessageCircle className="w-4 h-4" data-id="element-481" /> Antworten
                    </button>
                  </div>
                </div>

                {/* Comment 13 */}
                <div className="bg-white border border-gray-200 rounded-lg p-4 sm:p-5 mb-5 shadow-sm" data-id="element-482">
                  <div className="flex items-center gap-3 mb-4" data-id="element-483">
                    <div className="w-8 h-8 bg-brand-navy text-white rounded-full flex items-center justify-center font-bold text-sm" data-id="element-484">
                      k
                    </div>
                    <div data-id="element-485">
                      <div className="font-bold text-brand-navy text-sm" data-id="element-486">
                        karlundklaus
                      </div>
                      <div className="text-[10px] text-gray-500" data-id="element-487">
                        vor 10 Stunden
                      </div>
                    </div>
                  </div>
                  <p className="text-[14px] sm:text-[15px] text-gray-700 leading-relaxed mb-3 font-[Inter,_sans-serif]" data-id="element-488">
                    Mein Bruder (63) und ich (58) nehmen es beide seit 2
                    Monaten. Bei ihm hat es nach 10 Tagen gewirkt, bei mir nach
                    3 Wochen. Wir sind beide begeistert. Danke an Klaus für den
                    ehrlichen Bericht — ohne dich hätten wir das nie gefunden.
                  </p>
                  <div className="flex items-center gap-4 text-xs text-gray-500 font-medium" data-id="element-489">
                    <button className="flex items-center gap-1.5 hover:text-brand-navy transition-colors" data-id="element-490">
                      <ThumbsUp className="w-4 h-4" data-id="element-491" /> 23
                    </button>
                    <button className="flex items-center gap-1.5 hover:text-brand-navy transition-colors" data-id="element-492">
                      <MessageCircle className="w-4 h-4" data-id="element-493" /> Antworten
                    </button>
                  </div>
                </div>

                {/* Comment 14 */}
                <div className="bg-white border border-gray-200 rounded-lg p-4 sm:p-5 mb-5 shadow-sm" data-id="element-494">
                  <div className="flex items-center gap-3 mb-4" data-id="element-495">
                    <div className="w-8 h-8 bg-brand-navy text-white rounded-full flex items-center justify-center font-bold text-sm" data-id="element-496">
                      a
                    </div>
                    <div data-id="element-497">
                      <div className="font-bold text-brand-navy text-sm" data-id="element-498">
                        andi_fr79
                      </div>
                      <div className="text-[10px] text-gray-500" data-id="element-499">
                        vor 8 Stunden
                      </div>
                    </div>
                  </div>
                  <p className="text-[14px] sm:text-[15px] text-gray-700 leading-relaxed mb-3 font-[Inter,_sans-serif]" data-id="element-500">
                    Ehrliche Frage: Hat jemand Nebenwirkungen bemerkt? Ich
                    vertrage normalerweise nicht alles. Möchte es gerne
                    ausprobieren, bin aber vorsichtig.
                  </p>
                  <div className="flex items-center gap-4 text-xs text-gray-500 font-medium" data-id="element-501">
                    <button className="flex items-center gap-1.5 hover:text-brand-navy transition-colors" data-id="element-502">
                      <ThumbsUp className="w-4 h-4" data-id="element-503" /> 8
                    </button>
                    <button className="flex items-center gap-1.5 hover:text-brand-navy transition-colors" data-id="element-504">
                      <MessageCircle className="w-4 h-4" data-id="element-505" /> Antworten
                    </button>
                  </div>
                </div>

                {/* Author Reply to Andreas */}
                <div className="bg-[#fdf9eb] border border-[#f0e6c8] rounded-lg p-4 sm:p-5 ml-4 sm:ml-10 shadow-sm relative mb-5" data-id="element-506">
                  <div className="absolute -left-6 sm:-left-12 top-10 w-6 sm:w-12 h-px bg-gray-200" data-id="element-507"></div>
                  <div className="absolute -left-6 sm:-left-12 -top-10 w-px h-20 bg-gray-200" data-id="element-508"></div>
                  <div className="flex items-center gap-2 mb-2" data-id="element-509">
                    <CheckCircle2 className="w-3.5 h-3.5 text-brand-gold" data-id="element-510" />
                    <span className="text-[10px] font-bold text-brand-gold uppercase tracking-wider" data-id="element-511">
                      Autor
                    </span>
                  </div>
                  <p className="text-[14px] sm:text-[15px] text-gray-700 leading-relaxed font-[Inter,_sans-serif]" data-id="element-512">
                    @andi_fr79 Bei mir null Nebenwirkungen, auch nach 6 Monaten
                    nicht. Sind ja alles pflanzliche Inhaltsstoffe. Aber wenn du
                    unsicher bist, frag vorher deinen Arzt — sicher ist sicher.
                  </p>
                </div>

                {/* Comment 15 */}

                {/* Comment 16 */}
                <div className="bg-white border border-gray-200 rounded-lg p-4 sm:p-5 mb-5 shadow-sm" data-id="element-513">
                  <div className="flex items-center gap-3 mb-4" data-id="element-514">
                    <div className="w-8 h-8 bg-brand-navy text-white rounded-full flex items-center justify-center font-bold text-sm" data-id="element-515">
                      E
                    </div>
                    <div data-id="element-516">
                      <div className="font-bold text-brand-navy text-sm" data-id="element-517">
                        Erich47
                      </div>
                      <div className="text-[10px] text-gray-500" data-id="element-518">
                        vor 5 Stunden
                      </div>
                    </div>
                  </div>
                  <p className="text-[14px] sm:text-[15px] text-gray-700 leading-relaxed mb-3 font-[Inter,_sans-serif]" data-id="element-519">
                    Habe gerade bestellt. Bin 47 und stehe seit 3 Jahren jede
                    Nacht 3x auf. Mein Urologe sagt dasselbe wie bei dir Johan—
                    „alles normal". Hoffe, dass Nachton bei mir auch wirkt.
                    Melde mich in 4 Wochen zurück!
                  </p>
                  <div className="flex items-center gap-4 text-xs text-gray-500 font-medium" data-id="element-520">
                    <button className="flex items-center gap-1.5 hover:text-brand-navy transition-colors" data-id="element-521">
                      <ThumbsUp className="w-4 h-4" data-id="element-522" /> 11
                    </button>
                    <button className="flex items-center gap-1.5 hover:text-brand-navy transition-colors" data-id="element-523">
                      <MessageCircle className="w-4 h-4" data-id="element-524" /> Antworten
                    </button>
                  </div>
                </div>

                {/* Comment 17 */}
                <div className="bg-white border border-gray-200 rounded-lg p-4 sm:p-5 mb-5 shadow-sm" data-id="element-525">
                  <div className="flex items-center gap-3 mb-4" data-id="element-526">
                    <div className="w-8 h-8 bg-brand-navy text-white rounded-full flex items-center justify-center font-bold text-sm" data-id="element-527">
                      n
                    </div>
                    <div data-id="element-528">
                      <div className="font-bold text-brand-navy text-sm" data-id="element-529">
                        nobbi_mz
                      </div>
                      <div className="text-[10px] text-gray-500" data-id="element-530">
                        vor 3 Stunden
                      </div>
                    </div>
                  </div>
                  <div className="space-y-4 text-[14px] sm:text-[15px] text-gray-700 leading-relaxed mb-4 font-[Inter,_sans-serif]" data-id="element-531">
                    <p data-id="element-532">
                      Was mir besonders gefällt: keine dubiosen Inhaltsstoffe,
                      keine übertriebenen Versprechen auf der Webseite. Einfach
                      eine saubere Formel mit 8 Wirkstoffen, die aufeinander
                      abgestimmt sind.
                    </p>
                    <p data-id="element-533">
                      Nehme es seit 6 Wochen. Schlafe jetzt 5–6 Stunden am
                      Stück, vorher waren es maximal 2. Das ist für mich ein
                      Riesenunterschied.
                    </p>
                  </div>
                  <div className="flex items-center gap-4 text-xs text-gray-500 font-medium" data-id="element-534">
                    <button className="flex items-center gap-1.5 hover:text-brand-navy transition-colors" data-id="element-535">
                      <ThumbsUp className="w-4 h-4" data-id="element-536" /> 31
                    </button>
                    <button className="flex items-center gap-1.5 hover:text-brand-navy transition-colors" data-id="element-537">
                      <MessageCircle className="w-4 h-4" data-id="element-538" /> Antworten
                    </button>
                  </div>
                </div>

                {/* Comment 18 */}
              </>}
          </div>

          {/* CTA Section */}
          <div className="rounded-xl overflow-hidden mt-12 mb-10 shadow-lg border border-gray-200" data-id="element-539">
            {/* Magazine Header */}

            {/* CTA Body */}
            <div className="bg-[#2c4364] px-8 sm:px-10 py-8 sm:py-10 text-center" data-id="element-540">
              <h2 className="text-white sm:text-[28px] font-bold mb-4 font-[Merriweather,_serif] text-[18px]" data-id="element-541">
                Endlich wieder durchschlafen?
              </h2>
              <p className="text-gray-300 sm:text-base mb-8 font-['Open_Sans',_sans-serif] max-w-md mx-auto text-[15px]" data-id="element-542">
                Offizielle NachTon-Seite mit allen Details — Inhaltsstoffe,
                Erfahrungen, Bestellung.
              </p>
              <a href="https://nachton.de/products/nachton?utm_source=facebook&utm_medium=paid&utm_campaign=nachton_de&utm_content=adv_johan_erfahrungsbericht" target="_blank" rel="noopener noreferrer" className="bg-[#d4a338] hover:bg-[#c2932e] transition-colors text-white font-bold py-4 px-8 rounded-md w-full sm:w-auto inline-flex items-center justify-center gap-2 shadow-md text-[16px] font-['Open_Sans',_sans-serif] mb-6" data-id="element-543">
                Jetzt NachTon entdecken
                <ArrowUpRight className="w-5 h-5" data-id="element-544" />
              </a>
              <div className="text-[#8b9db5] text-[11px] sm:text-xs flex flex-wrap justify-center gap-x-2 gap-y-1 font-['Open_Sans',_sans-serif]" data-id="element-545">
                <span className="text-[12px]" data-id="element-546">8 Wirkstoffe in Synergie</span>
                <span className="hidden sm:inline" data-id="element-547">•</span>
                <span className="text-[12px]" data-id="element-548">100% natürlich</span>
                <span className="hidden sm:inline" data-id="element-549">•</span>
                <span className="text-[12px]" data-id="element-550">45-Tage-Vorrat</span>
              </div>
            </div>
          </div>

          {/* Disclaimer */}
          <div className="mt-12 mb-8" data-id="element-551">
            <hr className="border-gray-200 mb-6" data-id="element-552" />
            <p className="text-[#9ca3af] text-[10px] sm:text-[11px] text-center leading-relaxed font-['Open_Sans',_sans-serif] px-4" data-id="element-553">
              Anzeige — Dies ist ein bezahlter Erfahrungsbericht (Advertorial)
              und stellt keine medizinische Beratung dar. Individuelle
              Ergebnisse können variieren. NachTon ist ein
              Nahrungsergänzungsmittel und kein Ersatz für eine ausgewogene
              Ernährung und gesunde Lebensweise. Bei gesundheitlichen
              Beschwerden konsultieren Sie bitte Ihren Arzt oder Apotheker.
            </p>
          </div>
        </div>
      </main>

      {/* Footer */}
      <footer className="bg-[#2c4364] py-12 border-t border-[#1e2f48]" data-id="element-554">
        <div className="max-w-4xl mx-auto px-6 flex flex-wrap justify-center gap-x-8 gap-y-4 text-[#cbd5e1] text-[13px] font-['Open_Sans',_sans-serif]" data-id="element-555">
          <button onClick={() => openModal('impressum')} className="flex items-center gap-2 hover:text-white transition-colors" data-id="element-556">
            <FileText className="w-4 h-4" data-id="element-557" /> Impressum
          </button>
          <button onClick={() => openModal('datenschutz')} className="flex items-center gap-2 hover:text-white transition-colors" data-id="element-558">
            <Shield className="w-4 h-4" data-id="element-559" /> Datenschutzerklärung
          </button>
          <button onClick={() => openModal('agb')} className="flex items-center gap-2 hover:text-white transition-colors" data-id="element-560">
            <Lock className="w-4 h-4" data-id="element-561" /> Nutzungsbedingungen
          </button>
          <button onClick={() => openModal('widerruf')} className="flex items-center gap-2 hover:text-white transition-colors" data-id="element-562">
            <RefreshCcw className="w-4 h-4" data-id="element-563" /> Haftungsausschluss
          </button>
          <button onClick={() => openModal('cookie')} className="flex items-center gap-2 hover:text-white transition-colors" data-id="element-564">
            <Settings className="w-4 h-4" data-id="element-565" /> Cookie-Richtlinie
          </button>
        </div>
      </footer>

      {/* Legal Page Modal */}
      <AnimatePresence data-id="element-566">
        {activeModal && <motion.div initial={{
        opacity: 0
      }} animate={{
        opacity: 1
      }} exit={{
        opacity: 0
      }} className="fixed inset-0 bg-black/60 z-50 flex items-center justify-center p-4" onClick={closeModal} data-id="element-567">
            <motion.div initial={{
          scale: 0.95,
          opacity: 0
        }} animate={{
          scale: 1,
          opacity: 1
        }} exit={{
          scale: 0.95,
          opacity: 0
        }} transition={{
          type: 'spring',
          damping: 25,
          stiffness: 300
        }} className="bg-white rounded-lg shadow-2xl max-w-3xl w-full max-h-[90vh] overflow-hidden" onClick={e => e.stopPropagation()} data-id="element-568">
              {/* Modal Header */}
              <div className="bg-[#2c4364] px-6 py-5 flex items-center justify-between sticky top-0 z-10" data-id="element-569">
                <h2 className="text-white text-2xl font-bold font-[Merriweather,_serif]" data-id="element-570">
                  {legalContent[activeModal].title}
                </h2>
                <button onClick={closeModal} className="text-white hover:text-gray-300 transition-colors" aria-label="Schließen" data-id="element-571">
                  <X className="w-6 h-6" data-id="element-572" />
                </button>
              </div>

              {/* Modal Content */}
              <div className="px-6 py-8 overflow-y-auto max-h-[calc(90vh-80px)]" data-id="element-573">
                {legalContent[activeModal].content}
              </div>
            </motion.div>
          </motion.div>}
      </AnimatePresence>

      {/* Cookie Consent Banner */}
      <AnimatePresence data-id="element-574">
        {showCookieBanner && <motion.div initial={{
        y: 100,
        opacity: 0
      }} animate={{
        y: 0,
        opacity: 1
      }} exit={{
        y: 100,
        opacity: 0
      }} transition={{
        type: 'spring',
        damping: 25,
        stiffness: 300
      }} className="fixed bottom-0 left-0 right-0 bg-[#2c4364] border-t-2 border-[#d4a338] shadow-2xl z-40" data-id="element-575">
            <div className="max-w-6xl mx-auto px-6 py-6" data-id="element-576">
              <div className="flex flex-col sm:flex-row items-start sm:items-center justify-between gap-4" data-id="element-577">
                <div className="flex-1" data-id="element-578">
                  <h3 className="text-white font-bold text-lg mb-2 font-[Merriweather,_serif]" data-id="element-579">
                    Wir verwenden Cookies
                  </h3>
                  <p className="text-gray-300 text-sm font-['Open_Sans',_sans-serif] leading-relaxed" data-id="element-580">
                    Wir nutzen Cookies, um Ihnen die bestmögliche Nutzung
                    unserer Website zu ermöglichen. Einige sind notwendig,
                    andere helfen uns, die Website zu verbessern. Weitere
                    Informationen finden Sie in unserer{' '}
                    <button onClick={() => {
                  setShowCookieBanner(false);
                  openModal('datenschutz');
                }} className="text-[#d4a338] hover:text-[#c2932e] underline font-semibold" data-id="element-581">
                      Datenschutzerklärung
                    </button>{' '}
                    und{' '}
                    <button onClick={() => {
                  setShowCookieBanner(false);
                  openModal('cookie');
                }} className="text-[#d4a338] hover:text-[#c2932e] underline font-semibold" data-id="element-582">
                      Cookie-Richtlinie
                    </button>
                    .
                  </p>
                </div>
                <div className="flex flex-col sm:flex-row gap-3 w-full sm:w-auto" data-id="element-583">
                  <button onClick={() => handleCookieConsent('necessary')} className="px-6 py-3 bg-gray-600 hover:bg-gray-700 text-white font-semibold rounded-md transition-colors font-['Open_Sans',_sans-serif] text-sm whitespace-nowrap" data-id="element-584">
                    Nur notwendige
                  </button>
                  <button onClick={() => handleCookieConsent('all')} className="px-6 py-3 bg-[#d4a338] hover:bg-[#c2932e] text-white font-semibold rounded-md transition-colors font-['Open_Sans',_sans-serif] text-sm whitespace-nowrap shadow-md" data-id="element-585">
                    Alle akzeptieren
                  </button>
                </div>
              </div>
            </div>
          </motion.div>}
      </AnimatePresence>
    </div>;
}